function $84df55870a082396$export$2a08fff51aab5e(gradient) {
    return `linear-gradient(${gradient.degrees}deg, ${gradient.color1}, ${gradient.color2})`;
}
function $84df55870a082396$export$2e65e79124cca55d(color, gradient) {
    const all = document.getElementsByTagName("html")[0];
    all.style.background = "none";
    all.style.backgroundColor = color;
    if (gradient) all.style.background = $84df55870a082396$export$2a08fff51aab5e(gradient);
}
function $84df55870a082396$export$50d8e304f6fed8e6(className) {
    const elements = document.getElementsByClassName(className);
    while(elements.length > 0)elements[0].remove();
}
function $84df55870a082396$export$ec664d7487540b(imageDetails, classNames, id) {
    const image = document.createElement("img");
    image.src = imageDetails.path;
    image.alt = imageDetails.alt;
    image.classList.add(...classNames);
    image.id = id;
    return image;
}
function $84df55870a082396$export$6a1f9803a6325dab(source, classNames, id) {
    const audio = document.createElement("audio");
    audio.src = source;
    audio.classList.add(...classNames);
    audio.id = id;
    return audio;
}
function $84df55870a082396$export$47286723ded93599(text, classNames, id) {
    const span = document.createElement("span");
    span.innerText = text;
    if (classNames) span.classList.add(...classNames);
    if (id) span.id = id;
    return span;
}
function $84df55870a082396$export$45a83f42d92f1eb9(elementsToAdd, classNames, id) {
    const div = document.createElement("div");
    if (classNames) div.classList.add(...classNames);
    div.id = id;
    div.append(...elementsToAdd);
    return div;
}
function $84df55870a082396$export$3900c7b9aa762a08(text, classNames, goBack) {
    const button = document.createElement("button");
    button.innerText = text;
    button.classList.add(...classNames);
    button.id = "homeward";
    button.addEventListener("click", goBack);
    return button;
}
function $84df55870a082396$export$c92bc8fa290bd9eb(image, classNames, id) {
    const button = document.createElement("button");
    button.classList.add("image-button", ...classNames);
    button.id = id;
    button.append(image);
    return button;
}


const $7d616f599cf29980$export$826128ff895ed268 = {
    imFell: "IM Fell English",
    indieFlower: "Indie Flower",
    montserrat: "Montserrat",
    ebGaramond: "Garamond",
    rockSalt: "Rock Salt",
    reenieBeanie: "Reenie Beanie",
    nanumBrushScript: "Nanum Brush Script"
};
const $7d616f599cf29980$export$56d196d2844d1ca1 = {
    violet: "rgb(161, 84, 161)",
    dullViolet: "rgb(149, 128, 149)",
    paleViolet: "rgb(252, 243, 252)",
    indigo: "rgb(60, 45, 122)",
    cyan: "rgb(70, 220, 255)",
    blue: "rgb(53, 149, 210)",
    gold: "rgb(233, 194, 30)",
    lightYellow: "rgb(255, 255, 224)",
    dullGreen: "rgb(183,183,83)",
    green: "rgb(0, 128, 0)",
    red: "rgb(211, 50, 66)",
    white: "rgb(255, 255, 255)",
    black: "rgb(0, 0, 0)",
    gray: "rgb(128, 128, 128)",
    gainsboro: "rgb(220, 220, 220)",
    orange: "rgb(246, 138, 53)",
    dullOrange: "rgb(220, 166, 117)"
};
var $5fb6c98f42fe6aea$exports = {};
$5fb6c98f42fe6aea$exports = new URL("arrow-left-red.c4824080.png", import.meta.url).toString();


var $2d121c1aec716142$exports = {};
$2d121c1aec716142$exports = new URL("arrow-right-red.2da26508.png", import.meta.url).toString();


var $254cf57f19e39209$exports = {};
$254cf57f19e39209$exports = new URL("x.378c2d0c.png", import.meta.url).toString();


var $73e076bed8721f0c$exports = {};
$73e076bed8721f0c$exports = new URL("no-image.dd74ccb2.png", import.meta.url).toString();


var $bd5caa433d77c664$exports = {};
$bd5caa433d77c664$exports = new URL("paper.b2ce31b7.png", import.meta.url).toString();


const $7d616f599cf29980$export$1d6fe87f5e8f8dbd = {
    arrowLeft: {
        path: new URL($5fb6c98f42fe6aea$exports),
        alt: "hand-drawn next arrow"
    },
    arrowRight: {
        path: new URL($2d121c1aec716142$exports),
        alt: "hand-drawn back arrow"
    },
    x: {
        path: new URL($254cf57f19e39209$exports),
        alt: "hand-drawn close button"
    },
    noImage: {
        path: new URL($73e076bed8721f0c$exports),
        alt: ""
    },
    paper: {
        path: new URL($bd5caa433d77c664$exports),
        alt: "ball of paper"
    }
};






function $165860c33a72cffb$export$b8a77c3a46d1e455(text) {
    const lines = text.split(/\r?\n/);
    const paragraphs = [];
    lines.forEach((line)=>{
        let paragraph = document.createElement("p");
        paragraph.innerText = line;
        paragraphs.push(paragraph);
    });
    return paragraphs;
}



function $45d30e0da9a19151$var$loadImages(className, book) {
    book.forEach((chapter)=>{
        chapter.forEach((page)=>{
            if (!page.leftImage.imageLeft) page.leftImage.imageLeft = (0, $84df55870a082396$export$ec664d7487540b)(page.leftImage, [
                "reader-image",
                className,
                "reader-invisible"
            ], `${className}-reader-left-image`);
            if (!page.rightImage.imageRight) page.rightImage.imageRight = (0, $84df55870a082396$export$ec664d7487540b)(page.rightImage, [
                "reader-image",
                className,
                "reader-invisible"
            ], `${className}-reader-right-image`);
        });
    });
}
function $45d30e0da9a19151$export$3687857846e34983(className, book, imageBackgroundColor = (0, $7d616f599cf29980$export$56d196d2844d1ca1).white) {
    $45d30e0da9a19151$var$loadImages(className, book);
    let currentChapterIndex = 0;
    let currentTextIndex = 0;
    const storedChapterIndex = localStorage.getItem(`${className}ChapterIndex`);
    currentChapterIndex = storedChapterIndex ? parseInt(storedChapterIndex) : 0;
    const storedTextIndex = localStorage.getItem(`${className}TextIndex`);
    currentTextIndex = storedTextIndex ? parseInt(storedTextIndex) : 0;
    const leftArt = (0, $84df55870a082396$export$45a83f42d92f1eb9)([], [
        className,
        "reader-art"
    ], `${className}-reader-left-art`);
    leftArt.style.backgroundColor = imageBackgroundColor;
    const text = (0, $84df55870a082396$export$45a83f42d92f1eb9)([], [
        "reader-text"
    ], `${className}-reader-text`);
    const textContainer = (0, $84df55870a082396$export$45a83f42d92f1eb9)([
        text
    ], [
        className,
        "reader-text-container"
    ], `${className}-reader-text-container`);
    const rightArt = (0, $84df55870a082396$export$45a83f42d92f1eb9)([], [
        className,
        "reader-art"
    ], `${className}-reader-right-art`);
    rightArt.style.backgroundColor = imageBackgroundColor;
    const reader = (0, $84df55870a082396$export$45a83f42d92f1eb9)([
        leftArt,
        textContainer,
        rightArt
    ], [
        className,
        "reader-container"
    ], `${className}-reader-container`);
    document.getElementsByTagName("html")[0].append(reader);
    goToFragment(currentChapterIndex, currentTextIndex, false);
    function forward() {
        goToFragment(currentChapterIndex, currentTextIndex + 1, true);
    }
    function back() {
        goToFragment(currentChapterIndex, currentTextIndex - 1, false);
    }
    function removeHighlightLeft() {
        document.getElementById(`${className}-reader-left-image`)?.classList.add("reader-invisible");
        document.getElementById(`${className}-reader-left-art`).style.backgroundColor = imageBackgroundColor;
    }
    function removeHighlightRight() {
        document.getElementById(`${className}-reader-right-image`)?.classList.add("reader-invisible");
        document.getElementById(`${className}-reader-right-art`).style.backgroundColor = imageBackgroundColor;
    }
    function highlightLeft() {
        removeHighlightRight();
        const leftImage = document.getElementById(`${className}-reader-left-image`);
        if (currentChapterIndex > 0 || currentTextIndex > 0) {
            leftImage?.classList.remove("reader-invisible");
            document.getElementById(`${className}-reader-left-art`).style.backgroundColor = (0, $7d616f599cf29980$export$56d196d2844d1ca1).white;
        }
    }
    function highlightRight() {
        removeHighlightLeft();
        const rightImage = document.getElementById(`${className}-reader-right-image`);
        if (currentChapterIndex < book.length - 1 || currentTextIndex < book[book.length - 1].length - 1) {
            rightImage?.classList.remove("reader-invisible");
            document.getElementById(`${className}-reader-right-art`).style.backgroundColor = (0, $7d616f599cf29980$export$56d196d2844d1ca1).white;
        }
    }
    function goToFragment(chapterIndex, textIndex, isGoingForward) {
        if (chapterIndex === book.length) removeHighlightRight();
        else if (textIndex === book[chapterIndex].length) goToFragment(chapterIndex + 1, 0, false);
        else if (textIndex < 0) {
            if (chapterIndex !== 0) goToFragment(chapterIndex - 1, book[chapterIndex - 1].length - 1, false);
        } else if (isGoingForward && !(book[chapterIndex]?.[textIndex]?.canShow ?? (()=>true)())) alert("Explore more to keep reading.");
        else {
            if (chapterIndex === 0 && textIndex === 0) removeHighlightLeft();
            isGoingForward && textIndex === 0 || !isGoingForward && book[chapterIndex].length;
            const text = document.getElementById(`${className}-reader-text`);
            text?.querySelectorAll("h1").forEach((title)=>text.removeChild(title));
            text?.querySelectorAll("h2").forEach((poemTitle)=>text.removeChild(poemTitle));
            text?.querySelectorAll("p").forEach((paragraph)=>text.removeChild(paragraph));
            currentChapterIndex = chapterIndex;
            currentTextIndex = textIndex;
            localStorage.setItem(`${className}ChapterIndex`, `${chapterIndex}`);
            localStorage.setItem(`${className}TextIndex`, `${textIndex}`);
            const fragment = book[chapterIndex][textIndex];
            (0, $84df55870a082396$export$50d8e304f6fed8e6)("reader-image");
            document.getElementById(`${className}-reader-right-art`)?.append(fragment.rightImage.imageRight);
            document.getElementById(`${className}-reader-left-art`)?.append(fragment.leftImage.imageLeft);
            if (fragment.title) {
                let title = document.createElement("h1");
                title.innerText = fragment.title;
                text?.append(title);
            }
            if (fragment.heading) {
                let heading = document.createElement("h2");
                heading.innerText = fragment.heading;
                text?.append(heading);
            }
            if (fragment.text) (0, $165860c33a72cffb$export$b8a77c3a46d1e455)(fragment.text).forEach((paragraph)=>text?.append(paragraph));
            if (fragment.effect) fragment.effect();
        }
    }
    window.addEventListener("keydown", (event)=>{
        switch(event.code){
            case "KeyA":
            case "ArrowLeft":
                back();
                highlightLeft();
                break;
            case "KeyD":
            case "ArrowRight":
                forward();
                highlightRight();
                break;
            default:
                break;
        }
    });
    leftArt.addEventListener("mouseover", highlightLeft);
    leftArt.addEventListener("mouseleave", removeHighlightLeft);
    leftArt.addEventListener("click", back);
    rightArt.addEventListener("mouseover", highlightRight);
    rightArt.addEventListener("mouseleave", removeHighlightRight);
    rightArt.addEventListener("click", forward);
    return reader;
}







var $fd90808f7791db8b$exports = {};
$fd90808f7791db8b$exports = new URL("ambassador0.7d766bd5.webp", import.meta.url).toString();


var $5390322cbd768415$exports = {};
$5390322cbd768415$exports = new URL("ambassador1.34224693.webp", import.meta.url).toString();


var $b928feae8701ab48$exports = {};
$b928feae8701ab48$exports = new URL("ambassador2.8728ff94.webp", import.meta.url).toString();


var $509d9e4eb7907e92$exports = {};
$509d9e4eb7907e92$exports = new URL("ambassador3.7f2adb10.webp", import.meta.url).toString();


var $9d7d31a2b17e8e09$exports = {};
$9d7d31a2b17e8e09$exports = new URL("ambassador4.2e37acd7.webp", import.meta.url).toString();


var $6b1b002b8381299f$exports = {};
$6b1b002b8381299f$exports = new URL("ambassador5.189c3fcf.webp", import.meta.url).toString();


var $7f890fbb8699318c$exports = {};
$7f890fbb8699318c$exports = new URL("ambassador6.c123d838.webp", import.meta.url).toString();


var $e5bd2557d057d367$exports = {};
$e5bd2557d057d367$exports = new URL("ambassador7.6570c06f.webp", import.meta.url).toString();


var $4106982c75b6778d$exports = {};
$4106982c75b6778d$exports = new URL("niobe0.331c63b7.webp", import.meta.url).toString();


var $8b479c8432d72a63$exports = {};
$8b479c8432d72a63$exports = new URL("niobe1.9cade95c.webp", import.meta.url).toString();


var $7072f34c34234072$exports = {};
$7072f34c34234072$exports = new URL("niobe2.e72219aa.webp", import.meta.url).toString();


var $51ad68534bda81fb$exports = {};
$51ad68534bda81fb$exports = new URL("niobe3.7233fb80.webp", import.meta.url).toString();


var $3b0f2a283bc8a8f3$exports = {};
$3b0f2a283bc8a8f3$exports = new URL("niobe4.97a76a2f.webp", import.meta.url).toString();


var $a5d816999d0914d3$exports = {};
$a5d816999d0914d3$exports = new URL("creep0.ef5e8ab0.webp", import.meta.url).toString();


var $1d564a74fd5cb650$exports = {};
$1d564a74fd5cb650$exports = new URL("creep1.491a1ae0.webp", import.meta.url).toString();


var $3f431ce56236ed79$exports = {};
$3f431ce56236ed79$exports = new URL("creep2.a68b36bf.webp", import.meta.url).toString();


var $72366bff72c2a8a2$exports = {};
$72366bff72c2a8a2$exports = new URL("creep3.4077d8a4.webp", import.meta.url).toString();


var $6db5fd8bb2d02178$exports = {};
$6db5fd8bb2d02178$exports = new URL("creep4.6fb1e29e.webp", import.meta.url).toString();


var $07a123512557ea63$exports = {};
$07a123512557ea63$exports = new URL("creep5.bdb3fb1a.webp", import.meta.url).toString();


var $4eb1e7f2b0d9dd80$exports = {};
$4eb1e7f2b0d9dd80$exports = new URL("creep6.9351b1d0.webp", import.meta.url).toString();


var $db558707c9fc88f4$exports = {};
$db558707c9fc88f4$exports = new URL("beau0.f5f7b9f8.webp", import.meta.url).toString();


var $5a481a315753567f$exports = {};
$5a481a315753567f$exports = new URL("beau1.67e616de.webp", import.meta.url).toString();


var $8a3d08e13019f1a6$exports = {};
$8a3d08e13019f1a6$exports = new URL("beau2.34c27e60.webp", import.meta.url).toString();


var $b5586dbdd8fe9380$exports = {};
$b5586dbdd8fe9380$exports = new URL("beau3.edddf020.webp", import.meta.url).toString();


var $349b9c43a50cd462$exports = {};
$349b9c43a50cd462$exports = new URL("beau4.078a0192.webp", import.meta.url).toString();


var $ede83f4e9e683926$exports = {};
$ede83f4e9e683926$exports = new URL("beau5.2223e1a0.webp", import.meta.url).toString();


var $72c6b32f82741846$exports = {};
$72c6b32f82741846$exports = new URL("beau6.f463000b.webp", import.meta.url).toString();


var $e4530e530905df36$exports = {};
$e4530e530905df36$exports = new URL("knitter0.03a5bb09.webp", import.meta.url).toString();


var $aeb783e8b9e3d80f$exports = {};
$aeb783e8b9e3d80f$exports = new URL("knitter1.0722da82.webp", import.meta.url).toString();


var $71353f77322607e6$exports = {};
$71353f77322607e6$exports = new URL("knitter2.2423edf0.webp", import.meta.url).toString();


var $24c488c79b69f1df$exports = {};
$24c488c79b69f1df$exports = new URL("knitter3.93898031.webp", import.meta.url).toString();


var $9c75fab25d740e97$exports = {};
$9c75fab25d740e97$exports = new URL("knitter4.db01c23d.webp", import.meta.url).toString();


var $7f45c3925de5b430$exports = {};
$7f45c3925de5b430$exports = new URL("knitter5.3033883a.webp", import.meta.url).toString();


var $05290cd9e04c586a$exports = {};
$05290cd9e04c586a$exports = new URL("knitter6.a235153c.webp", import.meta.url).toString();


var $d3920cbc86ea7439$exports = {};
$d3920cbc86ea7439$exports = new URL("wrestle0.1776ac2c.webp", import.meta.url).toString();


var $fc607687f77d15c4$exports = {};
$fc607687f77d15c4$exports = new URL("wrestle1.cf4d675b.webp", import.meta.url).toString();


var $fb48a5ac1592cecb$exports = {};
$fb48a5ac1592cecb$exports = new URL("wrestle2.886fd69f.webp", import.meta.url).toString();


var $5d22c5337b27359c$exports = {};
$5d22c5337b27359c$exports = new URL("wrestle3.bab8bca4.webp", import.meta.url).toString();


var $19d6e2f46b45e8ca$exports = {};
$19d6e2f46b45e8ca$exports = new URL("wrestle4.5b11b6b1.webp", import.meta.url).toString();


var $ddb2140585acb11b$exports = {};
$ddb2140585acb11b$exports = new URL("wrestle5.65a80189.webp", import.meta.url).toString();


var $779c950f5197586f$exports = {};
$779c950f5197586f$exports = new URL("wrestle6.e0f7913b.webp", import.meta.url).toString();


var $ba58c8362011c619$exports = {};
$ba58c8362011c619$exports = new URL("wrestle7.0a6607a3.webp", import.meta.url).toString();


var $e4e1705eb530c953$exports = {};
$e4e1705eb530c953$exports = new URL("swans0.4b3d44b5.webp", import.meta.url).toString();


var $e07bc81d4f2af1b5$exports = {};
$e07bc81d4f2af1b5$exports = new URL("swans1.3d2f7d26.webp", import.meta.url).toString();


var $c517232a2b8da59d$exports = {};
$c517232a2b8da59d$exports = new URL("swans2.f6646632.webp", import.meta.url).toString();


var $c19a90eebee6864d$exports = {};
$c19a90eebee6864d$exports = new URL("swans3.efd4a35c.webp", import.meta.url).toString();


var $f60430ffd4c475af$exports = {};
$f60430ffd4c475af$exports = new URL("swans4.7c63b86f.webp", import.meta.url).toString();


var $a59d25e4eeae3dc2$exports = {};
$a59d25e4eeae3dc2$exports = new URL("swans5.d857ba8c.webp", import.meta.url).toString();


var $f34654d752e2da72$exports = {};
$f34654d752e2da72$exports = new URL("swans6.44bee58e.webp", import.meta.url).toString();


var $fef5f2c5b8f5676d$exports = {};
$fef5f2c5b8f5676d$exports = new URL("swans7.59b7c98e.webp", import.meta.url).toString();


var $bb4ed248e6252cf2$exports = {};
$bb4ed248e6252cf2$exports = new URL("blue0.9fec8561.webp", import.meta.url).toString();


var $5941e518eb6eca0e$exports = {};
$5941e518eb6eca0e$exports = new URL("blue1.cab663e6.webp", import.meta.url).toString();


var $5872ed0b2d296347$exports = {};
$5872ed0b2d296347$exports = new URL("blue2.f9e3067b.webp", import.meta.url).toString();


var $3781f182a0f74d3d$exports = {};
$3781f182a0f74d3d$exports = new URL("blue3.8e5084c0.webp", import.meta.url).toString();


var $c0891e94e305406a$exports = {};
$c0891e94e305406a$exports = new URL("chainlink0.6808a4e3.webp", import.meta.url).toString();


var $c1ecc315c5368572$exports = {};
$c1ecc315c5368572$exports = new URL("chainlink1.9237211f.webp", import.meta.url).toString();


var $23338415cd6fb895$exports = {};
$23338415cd6fb895$exports = new URL("chainlink2.a1a55fca.webp", import.meta.url).toString();


var $a69f828c86fac0d6$exports = {};
$a69f828c86fac0d6$exports = new URL("chainlink3.1044cf60.webp", import.meta.url).toString();


var $a5098f9e03497b1e$exports = {};
$a5098f9e03497b1e$exports = new URL("chainlink4.e886a202.webp", import.meta.url).toString();


var $d522fa4941eb8620$exports = {};
$d522fa4941eb8620$exports = new URL("egg0.ba32d16f.webp", import.meta.url).toString();


var $4203b40d0c5b5bb7$exports = {};
$4203b40d0c5b5bb7$exports = new URL("egg1.7f193ffe.webp", import.meta.url).toString();


var $dd8aa37f4248d68c$exports = {};
$dd8aa37f4248d68c$exports = new URL("egg2.822a7e99.webp", import.meta.url).toString();


var $e55df5a0886ee879$exports = {};
$e55df5a0886ee879$exports = new URL("egg3.d6e795a4.webp", import.meta.url).toString();


var $1d00f61f0875de42$exports = {};
$1d00f61f0875de42$exports = new URL("egg4.440741f9.webp", import.meta.url).toString();


var $424284d02509774e$exports = {};
$424284d02509774e$exports = new URL("egg5.35d86244.webp", import.meta.url).toString();


var $63d45c2c7be43970$exports = {};
$63d45c2c7be43970$exports = new URL("fb0.4230cbd1.webp", import.meta.url).toString();


var $c84dcdcd9d6740f2$exports = {};
$c84dcdcd9d6740f2$exports = new URL("fb1.53f2bfd1.webp", import.meta.url).toString();


var $e2a1e04974d7b4ad$exports = {};
$e2a1e04974d7b4ad$exports = new URL("fb2.bf746e97.webp", import.meta.url).toString();


var $43a55d991f054155$exports = {};
$43a55d991f054155$exports = new URL("fb3.63bb0671.webp", import.meta.url).toString();


var $5bb3a2628e199992$exports = {};
$5bb3a2628e199992$exports = new URL("fb4.cd76313f.webp", import.meta.url).toString();


var $1dc35f82e1f31a1e$exports = {};
$1dc35f82e1f31a1e$exports = new URL("fb5.45eaaa87.webp", import.meta.url).toString();


var $05e5405b520c6d07$exports = {};
$05e5405b520c6d07$exports = new URL("firebird0.fe223f33.webp", import.meta.url).toString();


var $d5f8a7ea9172bf3a$exports = {};
$d5f8a7ea9172bf3a$exports = new URL("firebird1.443e6c62.webp", import.meta.url).toString();


var $e1819d30a004ebc6$exports = {};
$e1819d30a004ebc6$exports = new URL("firebird2.95f996c8.webp", import.meta.url).toString();


var $06fa62caa3ba2918$exports = {};
$06fa62caa3ba2918$exports = new URL("firebird3.13c6bc80.webp", import.meta.url).toString();


var $4fceb6bddfbb178d$exports = {};
$4fceb6bddfbb178d$exports = new URL("firebird4.d101e2ed.webp", import.meta.url).toString();


var $51483d60f76c687d$exports = {};
$51483d60f76c687d$exports = new URL("firebird5.ea367a27.webp", import.meta.url).toString();


var $36169c579ae39a4a$exports = {};
$36169c579ae39a4a$exports = new URL("firebird6.7c27d616.webp", import.meta.url).toString();


var $bd3d99d394d589d5$exports = {};
$bd3d99d394d589d5$exports = new URL("goldcat0.72e03c6f.webp", import.meta.url).toString();


var $a6252b37d6cf7dec$exports = {};
$a6252b37d6cf7dec$exports = new URL("goldcat1.72d3d396.webp", import.meta.url).toString();


var $51f955f3c28f3677$exports = {};
$51f955f3c28f3677$exports = new URL("goldcat2.8adeddab.webp", import.meta.url).toString();


var $8dfa2c87759854d6$exports = {};
$8dfa2c87759854d6$exports = new URL("goldcat3.774f1dad.webp", import.meta.url).toString();


var $4c181ea5c0adafcb$exports = {};
$4c181ea5c0adafcb$exports = new URL("goldcat4.cbebf709.webp", import.meta.url).toString();


var $fc07762c0803d135$exports = {};
$fc07762c0803d135$exports = new URL("goldcat5.7641d23b.webp", import.meta.url).toString();


var $2b5d96acf48b6f21$exports = {};
$2b5d96acf48b6f21$exports = new URL("haircut0.80124676.webp", import.meta.url).toString();


var $e5a2206c221696e5$exports = {};
$e5a2206c221696e5$exports = new URL("haircut1.8aa7bbda.webp", import.meta.url).toString();


var $4b21d8adcd1114b2$exports = {};
$4b21d8adcd1114b2$exports = new URL("haircut2.92176a12.webp", import.meta.url).toString();


var $be4de6b244a4256e$exports = {};
$be4de6b244a4256e$exports = new URL("haircut3.15c6af47.webp", import.meta.url).toString();


var $be0ce011312a2e35$exports = {};
$be0ce011312a2e35$exports = new URL("haircut4.fe1cca50.webp", import.meta.url).toString();


var $ec3bb1c9e33f77b2$exports = {};
$ec3bb1c9e33f77b2$exports = new URL("haircut5.5a3f743e.webp", import.meta.url).toString();


var $540cd4411b837fcf$exports = {};
$540cd4411b837fcf$exports = new URL("haircut6.656d0db9.webp", import.meta.url).toString();


var $1e0e571e22a01004$exports = {};
$1e0e571e22a01004$exports = new URL("indigo0.76b62a9d.webp", import.meta.url).toString();


var $7713f84fc1acceee$exports = {};
$7713f84fc1acceee$exports = new URL("indigo1.ee7625bf.webp", import.meta.url).toString();


var $32ac7c9fcc8a4481$exports = {};
$32ac7c9fcc8a4481$exports = new URL("indigo2.e566e823.webp", import.meta.url).toString();


var $7b7a070e3ebc309d$exports = {};
$7b7a070e3ebc309d$exports = new URL("indigo3.38b28b9d.webp", import.meta.url).toString();


var $2f28d1802659c70d$exports = {};
$2f28d1802659c70d$exports = new URL("knitter-abstract0.73ea27bf.webp", import.meta.url).toString();


var $2f7da4753be2b2ee$exports = {};
$2f7da4753be2b2ee$exports = new URL("knitter-abstract1.ba5197cf.webp", import.meta.url).toString();


var $223c722053f534ca$exports = {};
$223c722053f534ca$exports = new URL("knitter-abstract2.38235d09.webp", import.meta.url).toString();


var $a449e0b66a84c515$exports = {};
$a449e0b66a84c515$exports = new URL("knitter-abstract3.a47fd874.webp", import.meta.url).toString();


var $2228a6310d163fee$exports = {};
$2228a6310d163fee$exports = new URL("knitter-abstract4.cb5c0be7.webp", import.meta.url).toString();


var $1a48e1b988319769$exports = {};
$1a48e1b988319769$exports = new URL("knitter-abstract5.8d122263.webp", import.meta.url).toString();


var $5ab6a99c8153be40$exports = {};
$5ab6a99c8153be40$exports = new URL("knitter-abstract6.5c237514.webp", import.meta.url).toString();


var $a1997417cea8eed3$exports = {};
$a1997417cea8eed3$exports = new URL("mirror1.dd2f1a2f.webp", import.meta.url).toString();


var $364f5b19c9364283$exports = {};
$364f5b19c9364283$exports = new URL("mirror2.5221c90b.webp", import.meta.url).toString();


var $165bab4ec96c6a52$exports = {};
$165bab4ec96c6a52$exports = new URL("mirror3.b57046fd.webp", import.meta.url).toString();


var $ef5690a715f42a2d$exports = {};
$ef5690a715f42a2d$exports = new URL("mirror4.46be108b.webp", import.meta.url).toString();


var $2fa824c3e489657d$exports = {};
$2fa824c3e489657d$exports = new URL("orange1.262be350.webp", import.meta.url).toString();


var $1e3d4aefdca52a95$exports = {};
$1e3d4aefdca52a95$exports = new URL("orange2.13bf9c4a.webp", import.meta.url).toString();


var $728caca4ae05fbce$exports = {};
$728caca4ae05fbce$exports = new URL("orange3.6e6121f2.webp", import.meta.url).toString();


var $e5a44d00a36c0fad$exports = {};
$e5a44d00a36c0fad$exports = new URL("orange4.55b54ada.webp", import.meta.url).toString();


var $2e2facf6b7400a07$exports = {};
$2e2facf6b7400a07$exports = new URL("orange5.a0187ee5.webp", import.meta.url).toString();


var $3240637916e2aab5$exports = {};
$3240637916e2aab5$exports = new URL("pins1.94e881a5.webp", import.meta.url).toString();


var $aebb03a564548b3a$exports = {};
$aebb03a564548b3a$exports = new URL("pins2.0d5a8e0e.webp", import.meta.url).toString();


var $d9ee1e41c642b379$exports = {};
$d9ee1e41c642b379$exports = new URL("pins3.72b8dfa6.webp", import.meta.url).toString();


var $1fd9b3a03c349f52$exports = {};
$1fd9b3a03c349f52$exports = new URL("pins4.ca7da0ba.webp", import.meta.url).toString();


var $7746db28ea1daaca$exports = {};
$7746db28ea1daaca$exports = new URL("pins5.41f5621e.webp", import.meta.url).toString();


var $9cd007463d9e79cf$exports = {};
$9cd007463d9e79cf$exports = new URL("rain0.b30db9b9.webp", import.meta.url).toString();


var $7921a696767c8a3a$exports = {};
$7921a696767c8a3a$exports = new URL("rain1.63681aa5.webp", import.meta.url).toString();


var $f778b0a6c28c8111$exports = {};
$f778b0a6c28c8111$exports = new URL("rain2.bf4cc7bd.webp", import.meta.url).toString();


var $d46277f949eae11f$exports = {};
$d46277f949eae11f$exports = new URL("rain3.ad96b865.webp", import.meta.url).toString();


var $20ca3f0bb6d8f4a7$exports = {};
$20ca3f0bb6d8f4a7$exports = new URL("rain4.cf30e3e5.webp", import.meta.url).toString();


var $31ce708d8769a4f5$exports = {};
$31ce708d8769a4f5$exports = new URL("rain5.47d33227.webp", import.meta.url).toString();


var $c95cc520a793354f$exports = {};
$c95cc520a793354f$exports = new URL("rain6.b7c4ec14.webp", import.meta.url).toString();


var $208ca1d5cb539b03$exports = {};
$208ca1d5cb539b03$exports = new URL("rain7.699761ed.webp", import.meta.url).toString();


var $38b1902bd69aed52$exports = {};
$38b1902bd69aed52$exports = new URL("suncat0.9a720834.webp", import.meta.url).toString();


var $521980e9637c1217$exports = {};
$521980e9637c1217$exports = new URL("suncat1.310e651a.webp", import.meta.url).toString();


var $5e03796a71f0a0e9$exports = {};
$5e03796a71f0a0e9$exports = new URL("suncat2.abd5839a.webp", import.meta.url).toString();


var $3af8c41d09aa44b6$exports = {};
$3af8c41d09aa44b6$exports = new URL("suncat3.cc2cf8c1.webp", import.meta.url).toString();


var $0b0ebff0a8e5cf0d$exports = {};
$0b0ebff0a8e5cf0d$exports = new URL("suncat4.1638db3c.webp", import.meta.url).toString();


var $b43ef11ef3605ae8$exports = {};
$b43ef11ef3605ae8$exports = new URL("suncat5.6b827494.webp", import.meta.url).toString();


var $ceefd28de1c31598$exports = {};
$ceefd28de1c31598$exports = new URL("tree0.ce86fe83.webp", import.meta.url).toString();


var $1d1161c0a1b0e919$exports = {};
$1d1161c0a1b0e919$exports = new URL("tree1.ecdf9e42.webp", import.meta.url).toString();


var $3dfa41816a53ca20$exports = {};
$3dfa41816a53ca20$exports = new URL("tree2.50123467.webp", import.meta.url).toString();


var $f1bf53b4ada9763f$exports = {};
$f1bf53b4ada9763f$exports = new URL("tree3.de1f5322.webp", import.meta.url).toString();


var $1a7e0e071f8b191e$exports = {};
$1a7e0e071f8b191e$exports = new URL("tree4.e92b35c8.webp", import.meta.url).toString();


var $c40cead0b4259171$exports = {};
$c40cead0b4259171$exports = new URL("tree5.d9e652e6.webp", import.meta.url).toString();


var $974218ed831be9b6$exports = {};
$974218ed831be9b6$exports = new URL("symbols.8a5d0166.webp", import.meta.url).toString();


var $d215606f72ec0e81$exports = {};
$d215606f72ec0e81$exports = new URL("august.661c6ed7.webp", import.meta.url).toString();


const $d67fc5261696adc7$export$83452b2d1d30567a = {
    ambassador0: {
        path: new URL($fd90808f7791db8b$exports),
        alt: "Light sketch of man with beard; click to go forward"
    },
    ambassador1: {
        path: new URL($5390322cbd768415$exports),
        alt: "Inked sketch of man with beard; click to go backward"
    },
    ambassador2: {
        path: new URL($b928feae8701ab48$exports),
        alt: "Inked sketch of man with beard, dark browns added; click to go forward"
    },
    ambassador3: {
        path: new URL($509d9e4eb7907e92$exports),
        alt: "Inked sketch of man with beard, mid-brown skin tones added; click to go backward"
    },
    ambassador4: {
        path: new URL($9d7d31a2b17e8e09$exports),
        alt: "Inked sketch of man with beard, dark browns added for hair; click to go forward"
    },
    ambassador5: {
        path: new URL($6b1b002b8381299f$exports),
        alt: "Inked sketch of man with beard, mid-brown skin tones added; click to go backward"
    },
    ambassador6: {
        path: new URL($7f890fbb8699318c$exports),
        alt: "Inked sketch of man with beard, lighter brown skin tones added; click to go forward"
    },
    ambassador7: {
        path: new URL($e5bd2557d057d367$exports),
        alt: "Inked sketch of man with beard, light skin and background tones added; click to go backward"
    },
    niobe0: {
        path: new URL($4106982c75b6778d$exports),
        alt: "Inked blue sketch of woman looking down; click to go forward"
    },
    niobe1: {
        path: new URL($8b479c8432d72a63$exports),
        alt: "Inked blue sketch of woman looking down, black facial feature outlines added; click to go backward"
    },
    niobe2: {
        path: new URL($7072f34c34234072$exports),
        alt: "Inked blue sketch of woman looking down, further black ink shading; click to go forward"
    },
    niobe3: {
        path: new URL($51ad68534bda81fb$exports),
        alt: "Inked blue sketch of woman looking down, splash of dull gold highlight across face; click to go backward"
    },
    niobe4: {
        path: new URL($3b0f2a283bc8a8f3$exports),
        alt: "Inked blue sketch of woman looking down, light paper tones added; click to go forward"
    },
    creep0: {
        path: new URL($a5d816999d0914d3$exports),
        alt: "Pale sketch of man with watch; click to go backward"
    },
    creep1: {
        path: new URL($1d564a74fd5cb650$exports),
        alt: "Darker sketch of man with watch; click to go forward"
    },
    creep2: {
        path: new URL($3f431ce56236ed79$exports),
        alt: "Sketch of man with watch, darker taupe skin tones added; click to go backward"
    },
    creep3: {
        path: new URL($72366bff72c2a8a2$exports),
        alt: "Sketch of man with watch, pale blue hat added; click to go forward"
    },
    creep4: {
        path: new URL($6db5fd8bb2d02178$exports),
        alt: "Sketch of man with watch, pink skin tones added; click to go backward"
    },
    creep5: {
        path: new URL($07a123512557ea63$exports),
        alt: "Sketch of man with watch, ivory and yellowish tones added; click to go forward"
    },
    creep6: {
        path: new URL($4eb1e7f2b0d9dd80$exports),
        alt: "Colored marker sketch of man with watch, completed; click to go forward"
    },
    beau0: {
        path: new URL($db558707c9fc88f4$exports),
        alt: "Black sketch animal eye; click to go forward"
    },
    beau1: {
        path: new URL($5a481a315753567f$exports),
        alt: "Black sketch dog's head, completed; click to go forward"
    },
    beau2: {
        path: new URL($8a3d08e13019f1a6$exports),
        alt: "Black sketch of dog's head and collar; click to go forward"
    },
    beau3: {
        path: new URL($b5586dbdd8fe9380$exports),
        alt: "Black sketch of dog's torso and front leg; click to go forward"
    },
    beau4: {
        path: new URL($349b9c43a50cd462$exports),
        alt: "Black sketch of dog with two legs showing; click to go forward"
    },
    beau5: {
        path: new URL($ede83f4e9e683926$exports),
        alt: "Black sketch of dog with all legs showing; click to go forward"
    },
    beau6: {
        path: new URL($72c6b32f82741846$exports),
        alt: "Complete black sketch of dog with all legs and tail; click to go forward"
    },
    knitter0: {
        path: new URL($e4530e530905df36$exports),
        alt: "Blue ink beginnings of drawing of woman bending her head over; Click to go forward"
    },
    knitter1: {
        path: new URL($aeb783e8b9e3d80f$exports),
        alt: "Blue ink beginnings of drawing of woman with black glasses added; Click to go forward"
    },
    knitter2: {
        path: new URL($71353f77322607e6$exports),
        alt: "Blue and black ink drawing of woman in glasses with brown shades added; Click to go forward"
    },
    knitter3: {
        path: new URL($24c488c79b69f1df$exports),
        alt: "Blue, black, and brown ink drawing of woman in glasses with red knitting project added; Click to go forward"
    },
    knitter4: {
        path: new URL($9c75fab25d740e97$exports),
        alt: "Ink drawing of woman knitting with pencil texture added; Click to go forward"
    },
    knitter5: {
        path: new URL($7f45c3925de5b430$exports),
        alt: "Ink and pencil drawing of woman knitting with paper color added; Click to go forward"
    },
    knitter6: {
        path: new URL($05290cd9e04c586a$exports),
        alt: "Completed ink and pencil drawing of woman knitting something red; click to go forward"
    },
    wrestle0: {
        path: new URL($d3920cbc86ea7439$exports),
        alt: "Pale sketch of woman and boy wrestling; click to go forward"
    },
    wrestle1: {
        path: new URL($fc607687f77d15c4$exports),
        alt: "Darker ballpoint pen sketch of woma and boy wrestling; click to go forward"
    },
    wrestle2: {
        path: new URL($fb48a5ac1592cecb$exports),
        alt: "Sketch of woman and boy wrestling with lighter blue of woman's jeans and jacket added; click to go forward"
    },
    wrestle3: {
        path: new URL($5d22c5337b27359c$exports),
        alt: "Sketch of woman and boy wrestling with olive green of boy's hoodie added; click to go forward"
    },
    wrestle4: {
        path: new URL($19d6e2f46b45e8ca$exports),
        alt: "Sketch of woman and boy wrestling with woman's red hair added; click to go forward"
    },
    wrestle5: {
        path: new URL($ddb2140585acb11b$exports),
        alt: "Sketch of woman and boy wrestling with yellowish skin tones added; click to go forward"
    },
    wrestle6: {
        path: new URL($779c950f5197586f$exports),
        alt: "Sketch of woman and boy wrestling with paper tones added; click to go forward"
    },
    wrestle7: {
        path: new URL($ba58c8362011c619$exports),
        alt: "Complete sketch of woman and boy wrestling; click to go forward"
    },
    swans0: {
        path: new URL($e4e1705eb530c953$exports),
        alt: "Light outline of one swan biting another; click to go forward"
    },
    swans1: {
        path: new URL($e07bc81d4f2af1b5$exports),
        alt: "Darker outline of one swan biting another with park in background in dark greens; click to go forward"
    },
    swans2: {
        path: new URL($c517232a2b8da59d$exports),
        alt: "One swan biting another in a park with red of turning trees and red-brown of dirt added; click to go forward"
    },
    swans3: {
        path: new URL($c19a90eebee6864d$exports),
        alt: "One swan biting another in a park with green grass and trees added; click to go forward"
    },
    swans4: {
        path: new URL($f60430ffd4c475af$exports),
        alt: "One swan biting another in a park with gray mountains added; click to go forward"
    },
    swans5: {
        path: new URL($a59d25e4eeae3dc2$exports),
        alt: "One swan biting another in a park with purple highlights added to the mountains; click to go forward"
    },
    swans6: {
        path: new URL($f34654d752e2da72$exports),
        alt: "One swan biting another in a park with blue sky added"
    },
    swans7: {
        path: new URL($fef5f2c5b8f5676d$exports),
        alt: "Completed marker drawing of one swan biting another in a park"
    },
    blue0: {
        path: new URL($bb4ed248e6252cf2$exports),
        alt: "Light blackish-blue sketch of woman with messy hair"
    },
    blue1: {
        path: new URL($5941e518eb6eca0e$exports),
        alt: "Blackish-blue sketch of woman with messy hair with lighter blue shading"
    },
    blue2: {
        path: new URL($5872ed0b2d296347$exports),
        alt: "Darker blackish-blue sketch of woman with messy hair"
    },
    blue3: {
        path: new URL($3781f182a0f74d3d$exports),
        alt: "Completed blue ballpoint sketch of woman with messy hair"
    },
    chainlink0: {
        path: new URL($c0891e94e305406a$exports),
        alt: "Black grid of Sharpie circles surrounded by scribbles in black ballpoint pen"
    },
    chainlink1: {
        path: new URL($c1ecc315c5368572$exports),
        alt: "Black grid of Sharpie circles surrounded by scribbles in black pen and pale blue patterns"
    },
    chainlink2: {
        path: new URL($23338415cd6fb895$exports),
        alt: "Black grid of Sharpie circles surrounded by scribbles in black and blue ballpoint pen and pale blue patterns"
    },
    chainlink3: {
        path: new URL($a69f828c86fac0d6$exports),
        alt: "Black grid of Sharpie circles surrounded by scribbles in black and blue ballpoint pen and pale blue patterns on cardboard"
    },
    chainlink4: {
        path: new URL($a5098f9e03497b1e$exports),
        alt: "Completed blue and black abstract artwork on cardboard"
    },
    egg0: {
        path: new URL($d522fa4941eb8620$exports),
        alt: "Black, gray and maroon abstract with lighter oval in the middle"
    },
    egg1: {
        path: new URL($4203b40d0c5b5bb7$exports),
        alt: "Black and red abstract with lighter oval in the middle"
    },
    egg2: {
        path: new URL($dd8aa37f4248d68c$exports),
        alt: "Red, black, and blue abstract with light gold oval in the middle"
    },
    egg3: {
        path: new URL($e55df5a0886ee879$exports),
        alt: "Abstract with gold oval against red, black, and blue background"
    },
    egg4: {
        path: new URL($1d00f61f0875de42$exports),
        alt: "Abstract with redder gold oval against red, black, and blue background"
    },
    egg5: {
        path: new URL($424284d02509774e$exports),
        alt: "Completed splatter abstract of gold egg shape against red, black, and blue background"
    },
    fb0: {
        path: new URL($63d45c2c7be43970$exports),
        alt: "Chaotic black- and brown-splattered canvas background with light cross shapes in front"
    },
    fb1: {
        path: new URL($c84dcdcd9d6740f2$exports),
        alt: "birdlike red and white cross shapes in front of chaotic black and red spattered background"
    },
    fb2: {
        path: new URL($e2a1e04974d7b4ad$exports),
        alt: "birdlike red and white cross shapes in front of chaotic black, gold, and red spattered background"
    },
    fb3: {
        path: new URL($43a55d991f054155$exports),
        alt: "birdlike red and white cross shapes in front of chaotic black, gold, blue, and red spattered background"
    },
    fb4: {
        path: new URL($5bb3a2628e199992$exports),
        alt: "birdlike red and teal cross shapes in front of chaotic black, gold, blue, and red spattered background"
    },
    fb5: {
        path: new URL($1dc35f82e1f31a1e$exports),
        alt: "Completed abstract with birdlike red and teal cross shapes in front of chaotic black, gold, and red spattered background"
    },
    firebird0: {
        path: new URL($05e5405b520c6d07$exports),
        alt: "Red painted shape of firebird head and drifting feather"
    },
    firebird1: {
        path: new URL($d5f8a7ea9172bf3a$exports),
        alt: "Red painted shape of firebird head and drifting feather"
    },
    firebird2: {
        path: new URL($e1819d30a004ebc6$exports),
        alt: "Red and gold painted shape of firebird head and drifting feather with suggestion of two gold globes"
    },
    firebird3: {
        path: new URL($06fa62caa3ba2918$exports),
        alt: "Red, gold, and yellow painted shape of firebird head and drifting feather with two gold globes"
    },
    firebird4: {
        path: new URL($4fceb6bddfbb178d$exports),
        alt: "Painting of firebird head with black pupils added and drifting feather, two gold and white globes in background"
    },
    firebird5: {
        path: new URL($51483d60f76c687d$exports),
        alt: "painting of red and yellow firebird head and drifting feather in front of iridescent ivory colored globes"
    },
    firebird6: {
        path: new URL($36169c579ae39a4a$exports),
        alt: "Completed, more vivid painting of red and yellow firebird head and drifting feather in front of iridescent ivory colored globes"
    },
    goldcat0: {
        path: new URL($bd3d99d394d589d5$exports),
        alt: "Black strokes of paint suggesting a cat"
    },
    goldcat1: {
        path: new URL($a6252b37d6cf7dec$exports),
        alt: "Black strokes of paint suggesting a cat with reddish highlights"
    },
    goldcat2: {
        path: new URL($51f955f3c28f3677$exports),
        alt: "Red, black, and tan painted sketch of a cat"
    },
    goldcat3: {
        path: new URL($8dfa2c87759854d6$exports),
        alt: "Painting of yellow-gold cat"
    },
    goldcat4: {
        path: new URL($4c181ea5c0adafcb$exports),
        alt: "Painting of yellow-gold cat with light blue highlights"
    },
    goldcat5: {
        path: new URL($fc07762c0803d135$exports),
        alt: "Completed painting of yellow-gold cat"
    },
    haircut0: {
        path: new URL($2b5d96acf48b6f21$exports),
        alt: "Red stripe extending almost halfway across a white background"
    },
    haircut1: {
        path: new URL($e5a2206c221696e5$exports),
        alt: "Red stripe on stylized black outline of woman getting haircut"
    },
    haircut2: {
        path: new URL($4b21d8adcd1114b2$exports),
        alt: "Woman getting haircut with gray cape beside gray and red box"
    },
    haircut3: {
        path: new URL($be4de6b244a4256e$exports),
        alt: "Woman getting haircut with gray cape beside gray and red box on green counter"
    },
    haircut4: {
        path: new URL($be0ce011312a2e35$exports),
        alt: "Woman getting haircut from strawberry blonde"
    },
    haircut5: {
        path: new URL($ec3bb1c9e33f77b2$exports),
        alt: "Drawing of woman getting haircut in her house with pale blue background and peach light coming in through window"
    },
    haircut6: {
        path: new URL($540cd4411b837fcf$exports),
        alt: "Completed drawing of woman getting haircut in her house"
    },
    indigo0: {
        path: new URL($1e0e571e22a01004$exports),
        alt: "Blue-black sketch of light radiating from white center"
    },
    indigo1: {
        path: new URL($7713f84fc1acceee$exports),
        alt: "Blue-black sketch of light radiating from humanoid white center"
    },
    indigo2: {
        path: new URL($32ac7c9fcc8a4481$exports),
        alt: "Blue-black sketch of light radiating from white human figure with dark patterns"
    },
    indigo3: {
        path: new URL($7b7a070e3ebc309d$exports),
        alt: "Completed blue-black sketch of light radiating from white human figure"
    },
    knitterAbstract0: {
        path: new URL($2f28d1802659c70d$exports),
        alt: "Stylized black sketch of woman looking down in chair"
    },
    knitterAbstract1: {
        path: new URL($2f7da4753be2b2ee$exports),
        alt: "Stylized black sketch of woman looking down in chair with blue outlines"
    },
    knitterAbstract2: {
        path: new URL($223c722053f534ca$exports),
        alt: "Stylized black sketch of woman looking down in chair colored over with blue marker."
    },
    knitterAbstract3: {
        path: new URL($a449e0b66a84c515$exports),
        alt: "Stylized black sketch of woman looking at red knitting in chair colored over with blue marker"
    },
    knitterAbstract4: {
        path: new URL($2228a6310d163fee$exports),
        alt: "Stylized sketch of woman looking at red knitting with peach light coming through glass bricks"
    },
    knitterAbstract5: {
        path: new URL($1a48e1b988319769$exports),
        alt: "Stylized sketch of woman looking at red knitting with peach and yellow light coming through glass bricks"
    },
    knitterAbstract6: {
        path: new URL($5ab6a99c8153be40$exports),
        alt: "Completed stylized sketch of woman who blends into blue background with red knitting and light coming through glass bricks"
    },
    mirror0: {
        path: new URL($a1997417cea8eed3$exports),
        alt: "Painting of brown-haired girl in pink shirt facing away"
    },
    mirror1: {
        path: new URL($364f5b19c9364283$exports),
        alt: "Painting of brown-haired girl and gold-haired woman in green floral print dress facing away"
    },
    mirror2: {
        path: new URL($165bab4ec96c6a52$exports),
        alt: "Painting of girl and woman facing empty mirror and pink paisley wall"
    },
    mirror3: {
        path: new URL($ef5690a715f42a2d$exports),
        alt: "Completed painting of girl and woman facing mirror showing girl's reflection radiating light"
    },
    orange0: {
        path: new URL($2fa824c3e489657d$exports),
        alt: "Curving lines of dark orange dots"
    },
    orange1: {
        path: new URL($1e3d4aefdca52a95$exports),
        alt: "Curving lines of dark orange dots outlining yellow gold roundish shapes"
    },
    orange2: {
        path: new URL($728caca4ae05fbce$exports),
        alt: "Abstract orange-outlined half-peeled orange"
    },
    orange3: {
        path: new URL($e5a44d00a36c0fad$exports),
        alt: "Abstract half-peeled orange with olive green shadow"
    },
    orange4: {
        path: new URL($2e2facf6b7400a07$exports),
        alt: "Completed marker sketch of half-peeled orange"
    },
    pins0: {
        path: new URL($3240637916e2aab5$exports),
        alt: "Rounded grid of red marker lines with dots and squiggles above"
    },
    pins1: {
        path: new URL($aebb03a564548b3a$exports),
        alt: "Black safety pin and threaded needle in red pincushion with red dots representing pinheads above"
    },
    pins2: {
        path: new URL($d9ee1e41c642b379$exports),
        alt: "Pincushion with red and yellow pinheads, threaded needle, and safety pin"
    },
    pins3: {
        path: new URL($1fd9b3a03c349f52$exports),
        alt: "Pincushion with red, yellow, and blue pinheads, threaded needle, and safety pin"
    },
    pins4: {
        path: new URL($7746db28ea1daaca$exports),
        alt: "Completed stylized marker sketch of pincushion with colorful pinheads, safety pin, and threaded needle"
    },
    rain0: {
        path: new URL($9cd007463d9e79cf$exports),
        alt: "Black and gray paint sketch of woman in chair"
    },
    rain1: {
        path: new URL($7921a696767c8a3a$exports),
        alt: "Black and gray paint sketch of woman in chair with mottled greenish background"
    },
    rain2: {
        path: new URL($f778b0a6c28c8111$exports),
        alt: "Black and gray paint sketch of woman in chair with mottled greenish background and purple shadows"
    },
    rain3: {
        path: new URL($d46277f949eae11f$exports),
        alt: "Black, purple, and gray paint sketch of woman in red chair with red lips"
    },
    rain4: {
        path: new URL($20ca3f0bb6d8f4a7$exports),
        alt: "Paint sketch of woman in red chair with peach and teal highlights"
    },
    rain5: {
        path: new URL($31ce708d8769a4f5$exports),
        alt: "Paint sketch of woman in red chair with lush green and purple background"
    },
    rain6: {
        path: new URL($c95cc520a793354f$exports),
        alt: "Paint sketch of woman in red chair with mid-brown shadows added"
    },
    rain7: {
        path: new URL($208ca1d5cb539b03$exports),
        alt: "Completed, if distorted, painting of woman in red chair against lush abstract garden"
    },
    suncat0: {
        path: new URL($38b1902bd69aed52$exports),
        alt: "Pale yellow marker-light shining on tan ledge; suggestion of white cat outline in negative space"
    },
    suncat1: {
        path: new URL($521980e9637c1217$exports),
        alt: "Pale yellow marker streaks down onto darker tan wood ledge; white cat outline in negative space"
    },
    suncat2: {
        path: new URL($5e03796a71f0a0e9$exports),
        alt: "Pale yellow marker streaks down onto darker tan wood ledge; green-eyed white cat outline in negative space"
    },
    suncat3: {
        path: new URL($3af8c41d09aa44b6$exports),
        alt: "Pale yellow marker streaks down onto darker tan wood ledge with black outline of a cat"
    },
    suncat4: {
        path: new URL($0b0ebff0a8e5cf0d$exports),
        alt: "green-eyed cat outlined in black on wooden ledge with red accents"
    },
    suncat5: {
        path: new URL($b43ef11ef3605ae8$exports),
        alt: "completed marker sketch of green-eyed cat outlined in black on wooden ledge with red accents"
    },
    tree0: {
        path: new URL($ceefd28de1c31598$exports),
        alt: "child's crayon and marker sketch of evergreen tree bearing different kinds of fruit"
    },
    tree1: {
        path: new URL($1d1161c0a1b0e919$exports),
        alt: "expressionistic painting of golden gate opening on pale-trunked tree with different kinds of fruit in green deluge"
    },
    tree2: {
        path: new URL($3dfa41816a53ca20$exports),
        alt: "digital painting of pale-trunked tree bearing many kinds of fruit falling into green deluge"
    },
    tree3: {
        path: new URL($f1bf53b4ada9763f$exports),
        alt: "cartoony marker drawing of wide-trunked tree bearing many kinds of fruit including the sun"
    },
    tree4: {
        path: new URL($1a7e0e071f8b191e$exports),
        alt: "Tree in fence on green hill painted with red, yellow, and blue leaves and red fruit"
    },
    tree5: {
        path: new URL($c40cead0b4259171$exports),
        alt: "detailed painting of tree with many kinds of fruit including the sun against teal sky"
    },
    symbols: {
        path: new URL($974218ed831be9b6$exports),
        alt: "Table with a different significant image named in each cell"
    },
    august: {
        path: new URL($d215606f72ec0e81$exports),
        alt: "Poem surrounded by gel pen art and stickers"
    }
};
const $d67fc5261696adc7$export$9c8bec6150a18d83 = [
    // [
    //   {
    //     heading: '12/20',
    //     text: `Often when I paint, I love the textures as much as the image, to the point I fear the abstraction of the parts is so much better than the naivete of the whole there is no reason to hitch them together.`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb0,
    //     rightImage: SKETCH_DIARY_IMAGES.fb0,
    //   },
    //   {
    //     text: `That's why I'm trying abstraction now (not total abstraction; you can see the firebirds if you look). Started this one with leftover paint.`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb1,
    //     rightImage: SKETCH_DIARY_IMAGES.fb1,
    //   },
    //   {
    //     text: `Abstraction is also more fun. Lower stakes? More creative? I almost paint in a trance.`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb2,
    //     rightImage: SKETCH_DIARY_IMAGES.fb2,
    //   },
    //   {
    //     text: `The result is, I fear, less rawly strange than my fantastical work, but perhaps a more understandable vision of what I saw.`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb3,
    //     rightImage: SKETCH_DIARY_IMAGES.fb3,
    //   },
    //   {
    //     text: `The irony of today's world: abstraction is more understandable than direct depictions of the thing?`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb4,
    //     rightImage: SKETCH_DIARY_IMAGES.fb4,
    //   },
    //   {
    //     text: `Evidently this reminds someone online of Stravinsky's Firebird. Just listened to that, and — yes.`,
    //     leftImage: SKETCH_DIARY_IMAGES.fb5,
    //     rightImage: SKETCH_DIARY_IMAGES.fb5,
    //   },
    // ], // firebird abstract
    [
        {
            heading: "Knitter",
            text: `Her love was what she made and not herself: in this case, the grandson for whom she knit the sweater. (Jennie understood. Jennie loves herself, yes, but next to \u{2014} that? Why even bother!?)`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter0
        },
        {
            text: `When Debbie met Jennie\u{2019}s eyes, she saw at first some kid who would make a mess, one of her son or grandson\u{2019}s friends. Even this inspired friendly humor, but she realized Jennie was quiet and not a material being, given that Jennie stood in front of her armchair where she sat with her beer and her cozy mystery and her knitting and had not entered the room in any way.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter1
        },
        {
            text: `This was not as concerning as she would have expected. She concluded she was dreaming, and Jennie produced something of her own, something more immaterial than she, Jennie \u{2014} like a painting or a window into another world in the shape of a garment, a robe shining with color and light. Debbie saw it was and was for another object of devotion, and they exchanged sly smiles.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter2
        },
        {
            text: `Jennie let Debbie go back to work \u{2014} but as she went splashed light on the sweater and the woman\u{2019}s hand, and it was revealed as the same kind of thing Jennie was making.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter3
        },
        {
            text: `Her grandson would value these knitted sweaters and hats, wearing them with an affectionate, self-deprecating grin well into adulthood, and this flame-red one would be his daughter\u{2019}s favorite when she was nine, even though her parents and friends found it \u{2014} loud, ungraceful, ungirly, and, of course, there was a hole in it by that point.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter4
        },
        {
            text: `She wore it when she was feeling sad for two years, and when she outgrew it she kept it \u{2014} her own son would not understand the fuss until one twilight when it almost seemed to glow, and he saw in it \u{2014} his mother as a girl, and then his grandfather as a boy, and then his great-great-grandmother knitting, and then an ageless flash of yellow-gold light that parted the world.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter5
        },
        {
            text: `(The original grandson, later grandfather, would have chosen as his favorite a different sweater, one from later years, a baggy, sturdy navy blue creation that he wore out hiking with their dog \u{2014} a sweet red dog, not unlike Ruff from Jennie\u{2019}s childhood \u{2014} and their daughter).`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitter6
        }
    ],
    [
        {
            heading: "Richert",
            text: `The worst of James Richert is also the best: he\u{2019}s a lecher, and lechery paints more beautiful and terrible images in even his unimaginative mind than any number of golf tournaments or conservative quips or mildly sleazy business practices.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep0
        },
        {
            text: `The conservative quips \u{2014} once they were something you said for the sake of saying something. But now the second-worst of him is the second-best \u{2014} conservative politics are a conviction, one that even  stretches to concern for his teenage daughter, who\u{2019}s saying she\u{2019}s lesbian. Though she hates him even more when he frames it as worry than when he just snorts and sneers. `,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep1
        },
        {
            text: `He glanced over to the other picnic table, at ten-year-old Jennie and her hot dog. \u{201C}One little piggy.\u{201D} His colleague, an older gentleman in an impeccable suit, made no reply, more inclined to wonder where the girl's parents were and why she looked so sad. Both men glanced again, and she caught them with dull brown eyes.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep2
        },
        {
            text: `The colleague was relieved. He\u{2019}d been wondering if he should offer to call someone for her. Her smile makes him think maybe he did, maybe he helped her find a parent or a teacher. He had a sense of ineffable warmth remembering her for years to come.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep3
        },
        {
            text: `Richert looked down, trapped in something gluey and burning. Look up again \u{2014} there's Jennie, finishing up her hot dog, bits of iceberg lettuce scattered on the wood picnic table. She glanced at him, snorted like a pig. There were pictures in the scalding. She was there too, though she\u{2019}s sort of smiling, middle aged. And a flash of perfect beauty.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep4
        },
        {
            text: `Such sights upset everything in a life. Richert broke up with his wife, apologized in tears to his daughter (who told him to go to hell in so many words and almost meant it), and nearly blew his brains out. Twenty years later, living alone, writing reams about the meaning of life, he's sure Jennie was the luckiest thing that ever happened to him.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep5
        },
        {
            text: `He explains this to his visiting colleague, who thinks he\u{2019}s lost his mind. He thinks the colleague\u{2019}s gains were ill-gotten and they should both give their remaining net worth to some charity or other, and the colleague is offended. The daughter and her mother never call, and Richert thinks that's more or less fair. He hopes someday they\u{2019}ll see what he saw.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.creep6
        }
    ],
    [
        {
            heading: "6/13 - Orange",
            text: `\u{201C}Needles and pins, needles and pins, when a man marries his troubles begin\u{201D}: nursery rhyme`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.pins0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.orange0
        },
        {
            text: `Abstractifying random objects. I like the orange, the layers and strangeness of color, green and gold, domestic sunlight, half-peeled, half-identifiable. The pincushion, schematic and child-bright, all primary colors, is not as interesting.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.pins1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.orange1
        },
        {
            heading: "8/11",
            text: `I didn't think these meant anything other than an exercise. I didn't think of the golden fruit and the needles. The fruit \u{2014} the fruit I ate elsewhere (am eating), sweet and burning and full of innumerable subtle flavors. But \u{2014} turned into a watery thing seen through glass, all about distortion and the tension between wild desire and mundane reality.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.pins2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.orange2
        },
        {
            text: `Re needles, a poem... 
Needles bind soft smooth silk or blotched pink skin. 
Exquisite, gold-wrought, white-hot needles pierce 
where the eye falls, too fine to see or stop.
That\u{2019}s how the seamstress marks our lives on us.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.pins3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.orange3
        },
        {
            text: `Debbie looked next upon the citrus fruit. Jennie, opposite her, said \u{2014} \u{201C}I\u{2019}m eating it \u{2014} it\u{2019}s fine \u{2014} you should have a bite too.\u{201D}
\u{201C}Who are you?\u{201D} Debbie asked.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.pins4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.orange4
        }
    ],
    [
        {
            heading: "Ambassador",
            text: `A soul of earth. Geoff spent the past few years with a nonprofit teaching drama. Loves his girlfriend, whiskey connoisseur. He has admirers, friends and coworkers and students. Warmth combined with vision will do that for a person.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador0
        },
        {
            text: `He sees beyond \u{2014} that's why he's in theater in the first place. I mean, the drama and artificiality, the humor, too. But desire took in him the shape of a longing for size and great deeds. As a kid, he wanted to change the world.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador1
        },
        {
            text: `Jennie was \u{2014} maybe a dream. Maybe not. If he was asleep he\u{2019}d be damned, but if it made any sense at all, he\u{2019}d be damned to hell and back. Jennie was a fat, mousy little white girl. He wanted her to come out of her shell, but she had stage fright, or something. "C'mon," he said. "You can be the princess. The prince. The bad guy. Anyone." Her refusal was absolute.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador2
        },
        {
            text: `\u{201C}That\u{2019}s for you,\u{201D} she said. \u{201C}Not for me.\u{201D} A trace of sadness in it, but also humor. Her dull brown puppy eyes met his, then, and he saw \u{2014} a fantasy world, with magic and heroes and villains, the kind of thing he\u{2019}d dreamed about as a bookworm boy.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador3
        },
        {
            text: `She was multitudes, like him, except it was real.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador4
        },
        {
            text: `They walked along the edge of a corn field under a hot blue sky, overhanging trees protecting him from the sun. (She walked in it, glanced over at it without squinting.) He found she loved his smiles and his roles too, but she wanted more from him, and he didn\u{2019}t have more to offer.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador5
        },
        {
            text: `He had more. He writhed and yelled when more hit him, for an instant \u{2014} where it came from he was not sure, then or later. She smiled ever so slightly, for the first time, and he literally bit his tongue to keep from cursing her out.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador6
        },
        {
            text: `Awe overcame him, and she smiled again and pointed to what he thought was a bird but turned out to be a sunset, fiery golds and reds, but still somewhat winged in shape, and set out toward it, and it grew for a time before fading.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador7,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.ambassador7
        }
    ],
    [
        {
            heading: "Wrestle",
            text: `Jacqueline and Dave had never been on a beach, but Jacqueline had wanted to for a long time. Why did she finally find herself on a beach in weather like this, though, where she couldn\u{2019}t even try out her aging bikini body (though she was not as old as she had once been)? It was windy, almost intolerable.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle0
        },
        {
            text: `Dave was not as fond of Jacqueline as she was of him \u{2014} she scared him, and what she saw as play he regarded as enmity, being a child. He looked to the side of people, even Jennie, though he was fonder of Jennie than of most. Mom was part of the world, a part of the world he could not (practically or emotionally) do without, but rarely a relevant or interesting part.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle1
        },
        {
            text: `Jennie was nowhere in sight. He wanted to find her. Jacqueline did not remember her.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle2
        },
        {
            text: `Right now Jacqueline could not understand what Dave was insisting on, thought it was part of an elaborate game of make-believe. Dave was, as far as she knew, an only child.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle3
        },
        {
            text: `Jennie sneaked up behind them, gave Dave a wink and a thumbs-up. He wriggled free and ran up the gray beach, his bare feet making puddles in the sand, disregarding rocks and jellyfish Mom and Jennie both would rather he attend to, but luck was with him. Still, Jennie was too far away to reach easily.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle4
        },
        {
            text: `Jennie reached him easily \u{2014} for her. They were together almost at once, in a sunny green field. But he ran across miles of beach, then climbed into rocky caves, up sheer slopes, and into shallow water. When the tide came in, and he dove into it, and eventually he arrived at a green space, lit by sun, where she was.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle5
        },
        {
            text: `They told each other stories: Dave of death-defying feats among the rocks, of the octopus he may or may not have seen, Jennie of a firebird and the stars. He asked her to come back. She refused. It was too far, too dull \u{2014} she would be like a trapped seabird. He was like a trapped seabird. He asked to join her.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle6
        },
        {
            text: `She told him to go dig a hole. Digging the hole would be finishing his life on earth, and when he was done, he could come back.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle7,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.wrestle7
        }
    ],
    [
        {
            heading: "Friend",
            text: `Beau was so glad to see Jennie there were no words. Not that Beau knew many words \u{2014} mostly the relevant ones, like \u{201C}walk,\u{201D} \u{201C}heel,\u{201D} \u{201C}sit,\u{201D} \u{201C}lie down,\u{201D} and, naturally, \u{201C}Beau.\u{201D} Beau was so glad he leaped up on her and she smiled and gave him a shy little hug.  Before that \u{2014} there'd been no one who smelled human or doglike or even catlike or squirrellike.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau0
        },
        {
            text: `He\u{2019}d shared his old house with a cat. The cat had not liked him, nor he her, but they\u{2019}d gotten to care about each other, he hoped. They had, Jennie reassured him. The cat had found comfort in Beau, even if he was annoying and loud and jumpy and licky and a dog. Jennie conveyed as much of this as she could, and he laughed. He was all those things and felt a little bad about it.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau1
        },
        {
            text: `Beau had met Jennie and liked her \u{2014} met her as an adult, that was. They hadn\u{2019}t interacted much. She\u{2019}d been in her own world, not interested in anyone. He understood her now, and, through her, more. He followed her off on a path somewhere brighter than he\u{2019}d ever followed his real humans, no leash. Jennie was a quiet kid, not like David and Holly\u{2019}s three girls.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau2
        },
        {
            text: `He felt he had to be polite to her, and to wherever they were going. Courtesy, solemnity \u{2014} or something \u{2014} came over him. He did not want to go further at some point and left \u{2014} wandered off into a green field. She said, \u{201C}Come back when \u{2014} it\u{2019}s time.\u{201D} And he would. He and That could wait for each other.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau3
        },
        {
            text: `He chased a bee. The bee stung him, but it didn\u{2019}t hurt. It almost tickled. He followed the bee into a thicket where he saw a ghost sadder than he had been, under trees so thick the sun could not come through. He tried to play with the ghost, lick it. It could not see him. He returned to the field and found David \u{2014} but David was younger now, Jennie\u{2019}s age if even that.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau4
        },
        {
            text: `Young David did not at first know the strange dog \u{2014} this was the wrong dog. The right dog was a curly, sweet golden retriever. But the new dog was faster, better at catch, than Ruff ever had been, and besides, he started to feel he should know this dog. Eventually he remembered his adulthood in a strange, small world, and remembered wishing he and Beau could have played when he was a child.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau5
        },
        {
            text: `It occurred to David he could find Ruff too. He called Beau to heel (Beau, as usual, didn\u{2019}t, exactly, a quality David had always admired in him, but he did follow). Beau realized he was trying to go the way Jennie had gone but could not find it. Beau was not sure he could find it any better than David could, but he could at least smell where Jennie had been.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.beau6
        }
    ],
    [
        {
            heading: "2/8 - Yellow",
            text: `Prickly claws are all the needles and biting allowed here, like the leaves of a thistle. The Narnian cat in The Horse and His Boy who is really Aslan \u{2014} this cat carries that gravity. She watches the spider crossing the bathroom floor and the small moth the spider stalks.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat0
        },
        {
            text: `The moth knows something of webs but not how to spot them when climbing the walls of a bathroom. Both lived their lives in a human house, benignly neglected, as a spider and a fly should be. The cat loves all life by now, though there is in both her attitude and her posture a temptation to pounce.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat1
        },
        {
            text: `The fluttering moth would do best, according to some ways of thinking, to get caught and killed by this spider and recreate themselves with knowledge of death and peril. The moth had not known death, not even on earth \u{2014} the moth had fluttered free from the cocoon and flown \u{2014} wildly, wildly \u{2014} up, up, and up to the screen.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat2
        },
        {
            text: `The humans caught the moth and set them free into the sky, and flying up brought the moth here, there, elsewhere, Evernost, not through the gate of death but through the gate of joy and cluelessness.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat3
        },
        {
            text: `No, the spider must not eat this moth, the cat decides, twitching her tail. She tenses her body, and the spider seeing, or sensing, scuttles under the wainscotting, which did not exist until the spider had need of it. Someone is going to have to kill that spider. Give the spider a body that might teach something more than hunger. (Spiders \u{2014} even spiders \u{2014} can do quite a lot if they care enough, but this one does not.)`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat4
        },
        {
            text: `My reference is, I think, an Abyssynian, there's a gold light about it, actual gold paint (I love sparkly and metallic colors immoderately), and many colors within the yellow-gold. All the color and chaos safely within the bounds of a cat.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.goldcat5
        }
    ],
    //   [
    //     {
    //       heading: '12/18',
    //       text: `When you look in this mirror you are radiant, the sun and the moon and the stars shine in your face, your very raiment glows.`,
    //       leftImage: SKETCH_DIARY_IMAGES.mirror0,
    //       rightImage: SKETCH_DIARY_IMAGES.mirror0,
    //     },
    //     {
    //       text: `She brought child-me there, showed me the wonder within, again and again, when I shrank and cringed and could not tolerate myself. Such things fade with much looking, they say, or they change. I — looked often, but only came to see it only with time, and with pain, until love even of myself burned in me like a flame and spread to all I saw.
    // `,
    //       leftImage: SKETCH_DIARY_IMAGES.mirror1,
    //       rightImage: SKETCH_DIARY_IMAGES.mirror1,
    //     },
    //     {
    //       text: `Some say the mirror shows lies. This is not true. It shows what we see when we look at the people we love most. I sank before that vision. I did not know it was even possible to live up to it. There were times I tried, but they felt like madness.`,
    //       leftImage: SKETCH_DIARY_IMAGES.mirror2,
    //       rightImage: SKETCH_DIARY_IMAGES.mirror2,
    //     },
    //     {
    //       text: `When I painted this, I stood outside the door, looking at my child self gazing into that mirror. I was other than human, gnarled, a monstrous black tree. I remembered then sensing a terror behind me.`,
    //       leftImage: SKETCH_DIARY_IMAGES.mirror3,
    //       rightImage: SKETCH_DIARY_IMAGES.mirror3,
    //     },
    //   ], // jennie in the mirror
    //   [    
    //     {
    //       text: `And it is the Love`,
    //       leftImage: SKETCH_DIARY_IMAGES.egg0,
    //       rightImage: SKETCH_DIARY_IMAGES.egg0,
    //     },
    //     {
    //       text: `It does not obliterate all else but gives birth to it, and if all else dies into it, it dies into them too.`,
    //       leftImage: SKETCH_DIARY_IMAGES.egg1,
    //       rightImage: SKETCH_DIARY_IMAGES.egg1,
    //     },
    //     {
    //       text: `Altogether Love is the root and beginning and end of all that is`,
    //       leftImage: SKETCH_DIARY_IMAGES.egg2,
    //       rightImage: SKETCH_DIARY_IMAGES.egg2,
    //     },
    //     {
    //       text: `At the extremes, the sublime turns to bathos. `,
    //       leftImage: SKETCH_DIARY_IMAGES.egg3,
    //       rightImage: SKETCH_DIARY_IMAGES.egg3,
    //     },
    //     {
    //       text: `This is the firebirds abstract only too much so.  There are butterfly stickers. Hard to photograph, too; light glints off every bit — glitter and metallic paint, jewellike stickers and white and yellow. The one radiance I failed to add was that of clarity, order, and image.`,
    //       leftImage: SKETCH_DIARY_IMAGES.egg4,
    //       rightImage: SKETCH_DIARY_IMAGES.egg4,
    //     },
    //     {
    //       text: `Someone online thought the big gold thing was too simple :(`,
    //       leftImage: SKETCH_DIARY_IMAGES.egg5,
    //       rightImage: SKETCH_DIARY_IMAGES.egg5,
    //     },
    //   ], // cosmic egg
    //   [
    //     {
    //       heading: 'when I was five',
    //       text: `The fruit plant I see from afar. It's a dream.`,
    //       leftImage: SKETCH_DIARY_IMAGES.tree0,
    //       rightImage: SKETCH_DIARY_IMAGES.tree0,
    //     },
    //     {
    //       heading: 'high school, senior year',
    //       text: `Tried a bunch of times in high school and the one I can find is this: supposed to be love, charity, the virtue (I painted seven deadly sins, then cardinal and theological virtues)`,
    //       leftImage: SKETCH_DIARY_IMAGES.tree1,
    //       rightImage: SKETCH_DIARY_IMAGES.tree1,
    //     },
    //     {
    //       heading: '9/8',
    //       text: `my going away present for my volunteer job`,
    //       leftImage: SKETCH_DIARY_IMAGES.tree3,
    //       rightImage: SKETCH_DIARY_IMAGES.tree3,
    //     },
    //     {
    //       heading: '6/4',
    //       text: `Scribbles, a Tree that belongs to earlier summer, exuberantly free, not intricately defined (in theory)`,
    //       leftImage: SKETCH_DIARY_IMAGES.tree4,
    //       rightImage: SKETCH_DIARY_IMAGES.tree4,
    //     },
    //     {
    //       heading: '10/14',
    //       text: `I have a job and feel empowered to spend time on weird art <3`,
    //       leftImage: SKETCH_DIARY_IMAGES.tree5,
    //       rightImage: SKETCH_DIARY_IMAGES.tree5,
    //     },
    //   ], // Tree of Life
    [
        {
            heading: "10/2 - Green",
            text: `The story I want to finish now is stranger than some of mine. Stupid and cold, some would say, genre fiction. And \u{2014} the greatness and power come from without, not within, and from above, not beside. That's supposed to be a bad thing, but I think it's just a way I process reality.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `I got the idea in high school \u{2014} a thirsty wooden grasshopper burst from the chest of a woman whose soul was as faded as mine before or worse, and she chased it into the forest of deep elsewhere, Evernost.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `The end just ripped itself out of me in a torrent like the one in which the antiheroine finds herself immersed, having been transformed into a tree root.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `I call this story Green, but green means more to me than that. It means, well \u{2014} take my fae bigender favorite author D, wild and enormous, able to go deep and dark as anything but most easily humorous \u{2014} with a humor that could destroy cities, creator of fictions that people sometimes took seriously and poems that only I know by heart.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `I learned more from D than from any other author about how to think and love visible reality. Once, I unilaterally hated its meaningless sorrow and dull detail. D taught me to see color and meaning, and to love the dark and odd hints of reality through the idealized lights and darks of fiction. `,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `And elsewhere contains the darkness, the melancholy wildness, D sees in it. I believe D has been elsewhere, seen it with their own deep eyes. Though D would just say elsewhere is a metaphor for the imagination.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `This can be agreeable at times. But elsewhere is more distant, beyond even the wildest imaginings, though there's little (if anything \u{2014} precisely nothing, I sometimes think) the imagination contains that elsewhere does not.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `But how was that ok, considering how horrific the imagination can be? Even just my imagination?`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        }
    ],
    // [
    //   {
    //     heading: '7/30',
    //     text: `My few brushes with the commercial art establishment in any area, writing or visual art, are rarely successful, usually because I'm awkward or withdraw.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I know my stuff is good. If anything, my problem is grandiosity — I see in my work not the actuality of it but the vision that brought it to me. It's not even that I fear what people will think of my work, though I do, in fits and starts. I just don't seem to care enough.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `That's why I <3 outsider art so much. I feel a deep, forbidden thrill when I read about it. The linework of Martin Ramirez and Madge Gill, the wild autobiography of Adolf Wolfli and the wilder fiction of Henry Darger — I want to see my kin there — or at the least, permission to create technically imperfect art.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // outsider art
    // [
    //   {
    //     heading: '5/24',
    //     text: `When I started writing about Evernost, the four on the island, I wrote an outline. Finally getting the energy to write about Emma: Emma, the princessy princess, creature of May, timid but valiant. Sweet Emma. I want to Emma to meet sweetness to match her own sweetness and planned it and did, an anachronistic fantasia in a tower.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `It's lovely like what awaits us all elsewhere, but less real, less of darkness and meaning to it. I hate it — do I ever not hate this stuff as I write it? Proud now it's done, though. Wanna finish — the rest of the novel, or possibly the trilogy, and still loathe because it's the simplest, most normal, least interesting part of Evernost..`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // spring and emma 
    // [
    //   {
    //     text: `Started this hoping to get it into a gallery, but it's too scribbly. Love the colors and textures. Love the feeling.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain0,
    //     rightImage: SKETCH_DIARY_IMAGES.rain0,
    //   },
    //   {
    //     text: `Elsewhere I seek, but I also live and wait. Secluded in a beautiful spot, outside some manor house, it was mine to dream, powerless, a sailor’s wife, waiting for news of one who might be living or dead. Here I sit in reverie it is only half-given me to love.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain1,
    //     rightImage: SKETCH_DIARY_IMAGES.rain1,
    //   },
    //   {
    //     text: `The wide world holds adventure, but my own garden is no mean thing for mysteries, guarded with thorns and the kind of strangeness that means you walk up to it and forget your intention to enter — or else, forget all else.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain2,
    //     rightImage: SKETCH_DIARY_IMAGES.rain2,
    //   },
    //   {
    //     text: `Yes, you can gaze at a flower, one of those little pinkish-white flowers on the waxy-leaved bush closest, say, for a century without losing interest — some infinity later a wind will blow off a petal or a drop of water will fall on it, shaking you awake or filling you with new and deeper strains of fascination`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain3,
    //     rightImage: SKETCH_DIARY_IMAGES.rain3,
    //   },
    //   {
    //     text: `The sun — the white and ordinary house some yards away — the red wooden chair in which she sat — all conspire to keep me from lying down in the garden to sleep.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain4,
    //     rightImage: SKETCH_DIARY_IMAGES.rain4,
    //   },
    //   {
    //     text: `She would, if she had the strength, stand up. She would not go near the garden. She would enter the house, start some supper, buy groceries.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain5,
    //     rightImage: SKETCH_DIARY_IMAGES.rain5,
    //   },
    //   {
    //     text: `The colors and textures in this painting compelled me, though I'll paint over most of it. I like the woman's cadaverous face.`,
    //     leftImage: SKETCH_DIARY_IMAGES.rain6,
    //     rightImage: SKETCH_DIARY_IMAGES.rain6,
    //   },
    //   {
    //     text: `I'll make her Ophelia someday, who will, when spring warms, sink into the pools of the dark spaces of the garden, where the sun could not be seen. `,
    //     leftImage: SKETCH_DIARY_IMAGES.rain7,
    //     rightImage: SKETCH_DIARY_IMAGES.rain7,
    //   },
    // ], // rain
    [
        {
            heading: "11/10 - Blue",
            text: `Why did I buy this dress?`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue0
        },
        {
            text: `Spaghetti-strap royal blue velvet dress with the chintzy gold trim from the very back of Goodwill. I have nowhere to wear it.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue1
        },
        {
            text: `Used to be vegetarian. Now I know plants are people too, and I just try to honor everything I eat with a thought as I eat it.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue2
        },
        {
            text: `Maybe the more I honor the personhood of what I eat, the more I like the objecthood of the meat I am. At least, if you're to go by this ridiculous garment.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.blue3
        }
    ],
    // [
    //   {
    //     heading: '6/30',
    //     text: `Have been reading about allegory at the university library.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I read a study by J (a scholar as well as a lay philosopher; though renowned in its field, it's strained and confused, not at all up to the standards of J’s other writing, for all that its insights and sharp-edged definitions help me understand). Read another one too, but it's a little too far out for me.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `That's euphemistic. It's profoundly irrational. Elevates tenuous etymological connections to the status of fact, presents dubious similarities between disparate works as watertight proofs of arguments more bizarre than any I would have come up at my wildest. And, worst, it reduces beauty to power.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Yet this book's absurdity is almost surrealism, dream-logic — nightmare logic. Even the hells are beautiful, and the taste for strangeness and horror runs deep in humanity — one hopes the hells are temporary — or chosen — but also that the beauty of strangeness was real and permanent, and — this book surely expresses the beautiful strangeness of some hell or other`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I hope for the author’s sake he doesn't believe what he wrote. Or even that he does and, and, dull cynic, does not live his belief.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I want to write allegories, though.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // allegory
    // [
    //   {
    //     heading: '10/8',
    //     text: `I have intuitions about infinity and eternity, but they won't stay still. I can't see them most of the time, let alone articulate them to myself, let alone communicate them to others.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I half want to learn math. That's the best tool for grasping infinity, these days, yes?`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Every now and then I try to resurrect high school calculus, check out textbooks from the college library, in hopes I can motivate myself beyond that into the stuff that involves proofs and the delight of problem solving.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I was good at high school math, but I doubt I could go much beyond that and easy puzzles, though. If I didn't doubt I'd still be afraid, afraid I'd break my heart by learning all my intuitions and hopes are nonsense.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // math
    // [
    //   {
    //     heading: '12/2',
    //     text: `But I want not just the chaos of earthly things. I want the complex orchestrated harmony of the skies. Try as I might, though, I can't get a sky I like. I get fragments, peripheries, and even those are nearly impossible to get right.`,
    //     leftImage: SKETCH_DIARY_IMAGES.chainlink0,
    //     rightImage: SKETCH_DIARY_IMAGES.chainlink0,
    //   },
    //   {
    //     text: `Colors, a chain link fence against the night sky; she climbs the links of cast iron, rough. She meets shapes in their surfaces like faces, but too empty. She hears someone else climbing, above or behind or before, but they do not answer when she calls — though her voice echoes in a way the space does not explain. `,
    //     leftImage: SKETCH_DIARY_IMAGES.chainlink1,
    //     rightImage: SKETCH_DIARY_IMAGES.chainlink1,
    //   },
    //   {
    //     text: `Between them are the shapes of four-pointed stars. From a sufficient distance, she supposes, they would look like real stars.`,
    //     leftImage: SKETCH_DIARY_IMAGES.chainlink2,
    //     rightImage: SKETCH_DIARY_IMAGES.chainlink2,
    //   },
    //   {
    //     text: `The rough iron hurts her hands, but she is weightles and can climb with little effort. She would like to swim the blue, but she fears. When she comes to the edge of the cube, she hesitates and then strides out, crossing swathes of blue until`,
    //     leftImage: SKETCH_DIARY_IMAGES.chainlink3,
    //     rightImage: SKETCH_DIARY_IMAGES.chainlink3,
    //   },
    //   {
    //     text: `she comes to the gray of the stars and it is — just desolation. The bit of sky is too small and false to return to. She trudges on. The vision there is not hers.`,
    //     leftImage: SKETCH_DIARY_IMAGES.chainlink4,
    //     rightImage: SKETCH_DIARY_IMAGES.chainlink4,
    //   },
    // ], // chainlink sky
    [
        {
            heading: `Niobe`,
            text: `The woman was old and sad and elsewhere. She was not a single, literal woman from our world; at least, if she was, for whatever reason I cannot give you a name and a story. She sat like a rock. Strong and leathery, she was no storied queen. She saw a formless gray, but with the superficial features of a city.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe0
        },
        {
            text: `Jennie saw no city. She saw a mountainside in May, covered in grass and wildflowers, and a rock overlooking it halfway up, a spring under the rock. At first Jennie did not see the woman on the rock, eyes fixed on her folded hands, incongruous and misplaced Piet\xe0.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe1
        },
        {
            text: `Jennie, grave-eyed child, gave her a hug. Then, Jennie giggled, pointed up, and darted off. The hug had changed something. This giggle did not change a single muscle in the woman\u{2019}s face. It was \u{2014} a strange giggle. Almost cruel. But not quite, because Jennie was almost certain it would be all right. Was all right.
`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe2
        },
        {
            text: `The woman did not look up. But the sun looked down, and began asking her about her troubles. Eventually perhaps she found a word in her to reply and then another, until she stormed at the sun and his sister the moon and received gnomic responses. She cried out that truth without mercy was no truth at all, that the hardness of the universe was a crime.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe3
        },
        {
            text: `Jennie was long gone. She was finite and had many places to be. But the Sun was not so simple or singular. Perhaps the woman was to mourn forever \u{2014} there were those who believe mourning is central to reality \u{2014} Jennie was not one of them, and she thought the sun would win. She did not ask whether the sun might be the culprit.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.niobe4
        }
    ],
    [
        {
            heading: "10/19 - Indigo",
            text: `\u{201C}Enough fear and floundering,\u{201D} said the voice, a high voice with something of bells about it. Jennie threw open the curtain to her basement room and saw not the Man in the Moon but \u{2014} Celeste, the star from Evernost Verna had caught? No \u{2014} names like Celeste were the thin and stupid nonsense \u{2014} `,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo0
        },
        {
            text: `\u{201C}I am something of what you seek, yes,\u{201D} said that high voice, and the glass was filled with singing light for a moment before the being sat smiling at the foot of her bed. Jennie could tell the figure spoke the truth, held the goodness and beauty of elsewhere. \u{201C}What would you have of me? You have work. You have creation. You have your family.\u{201D}`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo1
        },
        {
            text: `Jennie almost begged, though she was still dull and quiet and sleepy, a little thin and false and disconnected, to go back with the light. But either her unspoken promise to remain \u{2014} or the dullness and sleepiness and falsity of her \u{2014} stayed her tongue. Instead, she reached out to the light, and light took her in its arms, held her to its wild heart.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo2
        },
        {
            text: `\u{201C}Just stay,\u{201D} she begged the figure of light. \u{201C}Stay a little longer. I love you. I love you more than the rest of this.\u{201D} But it only danced in her blood, and around her room, and kissed her, and flew. She did not even have something to put on her altar, and she was told at once she would forget, this was too good, too good to be true, too good to be allowed.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.indigo3
        }
    ],
    [
        {
            text: `Coworker Sonia's pretty. Blonde. Thinnish. Very, very kind and strong-hearted in the moral convictions of her time \u{2014} liberal and disgusted with abuse and dishonesty and sexism. Started shy and anxious, but the others had brought her out of her shell. She tries to bring me out of my shell, and was consistently kind.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `I dreamed last night of Sonia caught in vines. I tried to look for the forest spirit, up and down and everywhere, and to rebuke the vines growing into Sonia\u{2019}s skin, and not to look at Sonia, whose clothes were ripped to shreds. If I'd ripped the vines free, I might have killed Sonia. \u{201C}I am sorry,\u{201D} I said, but Sonia was dreaming too deep to hear.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `At work today Sonia said she\u{2019}d had a lovely dream. Lovely. But embarrassing to talk about, apparently \u{2014} she blushed and would say no more. I was shaking before I even drank my tea.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        }
    ],
    // [
    //   {
    //     heading: '7/5',
    //     text: `Every now and then I want to go to grad school, study literature and become a literary scholar. Pretty...funny. I'm too unscientific and too much of a generalist for how little she know and the archaic frameworks in which I know it.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Dream of writing a study: On Truth and the Imagination in a Moral Sense, after Nietzsche, lol. Haven't gotten far.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Instead, this time I wrote more about D, who taught me to see elsewhere in reality and abstraction.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Even there, it's hard to choose an idea. I could compare D with William Blake, but that's a bit wild, as D's a children's writer and almost contemporary.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Maybe D and happy endings (D wrote deeply melancholy work but still stood up for happy endings and tried to write them);`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `But I went for an exploration of the concept of truth in D’s work. D's strange on truth. They accept it and do not accept it — like the relativism that maddens me, but D's joy in it makes it palatable. `,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Wrote a 5000-word essay, started to edit and add references, and — could not. Perhaps it's not time. Evernost calls.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // theory
    // [
    //   {
    //     heading: '9/30',
    //     text: `Romantic theorists counterpoised symbol against allegory — supposedly, symbols partake of what they mean rather than (supposedly) being a sterile intellectual exercise. Symbols are hard to pin down, perhaps possessed of deep psychological or metaphysical meaning.`,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    //   {
    //     text: `I'm contemporary enough not to buy the distinction. Allegory (whether you mean by that, as J meant, something where abstractions walked around wearing names, or whether you mean any narrative with a sustained second layer of meaning) at its best holds both depth and play. My ideas for an allegory to write have been eclipsed, but maybe I'll find...symbols?`,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    //   {
    //     text: `Or significant images, at least. My mind, every mind, is full of associations and colors and meanings waiting to be unearthed — and I'm sick of waiting for them to emerge on their own.`,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    //   {
    //     text: `A few of my symbols are simple. Easy to identify. Firebirds — yes. Even as a very young girl, I drew them, elongated, shapeless red phoenix-things. The sun and the moon and the stars, as well as great trees, have haunted my pen all my life. `,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    //   {
    //     text: `I've seen studies discussing the emergent symbols in poets’ work, observed them in the poets I translate. So I'm working out my own list — let them mean what they choose to mean and sprinkle them among other modes of creation.`,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    //   {
    //     text: `I draw from the natural world. I've checked out books of symbols, on the language of flowers, on superstitions, but I didn't get far with that.`,
    //     leftImage: SKETCH_DIARY_IMAGES.symbols,
    //     rightImage: SKETCH_DIARY_IMAGES.symbols,
    //   },
    // ], // symbols
    // [
    //   {
    //     heading: '9/1',
    //     text: `August turning to September, hate turns to dissolution. The winds blows cooler. Evernost reabsorbs the Kingdom, giving everything within it endless and (ultimately) incomparably better life.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `But this is hard to write. I can scrounge up only a few scraggly stories and — I can't see the firebird, or even myself, clearly enough to write what becomes of these people.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I have to wait — still to wait, always to wait.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `I wanted to write a Dissolution story for every single inhabitant of the Kingdom (how?) or at least a representative cross-sample across time and space and social strata. `,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Not a single story is coming through in its right shape.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // dissolution
    [
        {
            heading: "6/11 - Violet",
            text: `Sonia at work just dyed her hair purple for Pride Month.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `I wonder if I should, and then I get upset. Too upset. I don't get it.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `The love I need is over the hills and far away. Love is beautiful in every form, and painful.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        },
        {
            text: `Supposedly I need to annoy my mother by dyeing my hair a ridiculous color.`,
            leftImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage,
            rightImage: (0, $7d616f599cf29980$export$1d6fe87f5e8f8dbd).noImage
        }
    ],
    //   [
    //     {
    //       heading: '6/29',
    //       text: `Sonia said blue is her primary aura color, based on a quiz. Jordan was skeptical, Delaney bubblingly fascinated. S.L. half-bought it and had strong intuitions about everyone’s aura colors — they saw a red and orange and gold and violet around Delaney, agreed with Sonia about blue and saw red in Jordan.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `I can sometimes imagine something other than skin and hair and clothes, but I don't like the systems that spring up around colors; my own perceptions are — at times metaphorical along those lines but much more complex. `,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `Felt sad listening to S.L.’s laughing aura readings. S.L. always does the thing I do, but makes it faster and lighter and more colorful. And S.L. said to me, “I don’t know about you. I — I don’t feel much of anything.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `“There are lots of different pieces,” I said, “but I think I’m more receptive than anything.” 
    // “That’s called Crystal,” said Sonia. “I could see it.”`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `Then I got auras stuck in my head. Delaney laughed a pink, bubbling laugh and burbled off — Sonia looked a little pained and serious, a field of the high, clear sky-blue light, rippling into an awkward non-Duchenne laugh. S.L. listened,  abstract and restless — their attention was poppy print, black and magenta and red and yellow and turquoise, in a fiery aesthetic alien to mine.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `Kay came over at this, and I admired at first the humanity of him — saw him in skin tones, backed by an exacting ink-blue or-black thing of fierce intellect and awareness of darkness. Then he was the wizard in the tower, calling down lightning in the black night. All definition where S.L. had none.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //   ], // auras
    //   [
    //     {
    //       heading: '10/18',
    //       text: `The light coming in Jennie’s window that night was too bright even to be Mom’s floodlight, which came on automatically when anything stirred in the backyard. Jennie went back to sleep.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `Jennie also floated up through the window and the night into a saucer of a substance impossibly black even in the night sky; the moon shone and the stars shone and the streetlights shone, but nothing was reflected from it.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `There were three rubbery Grays at the helm. She knew she’d seen them before. They were shorter than Jennie right now; they changed size. The saucer changed shape. None of that was important.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `The aliens did not want her for medical experiments this time. They’d learned what there was to learn, they said. They’d bred enough hybrid babies to help them preserve the human race in case it wiped itself out of existence, and to enrich their own culture. They wanted to repay her for her trouble. They wanted to give her a bit of the big picture.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `They told her the fate of the earth, which she would not remember, except for this: Evernost, if you would, was coming. It could come as terror and destruction, or it could come as glory beyond all imagining. Probably it would come as both, and more. Jesus was coming again. Perhaps literally, definitely figuratively.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `They talked (as aliens in abductions are wont to do) about the environment. They had solutions. Jennie would not remember the solutions, only that they felt as o/Outlandish as her own, which involved rewriting the laws of physics. There was some overlap, but not total.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `Jennie awoke groggy, with a headache and a suspicion that she had lost track of something important. She kept writing all the same, with painful effort, but then something else grabbed me.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `It was from the visions of others, not my own, conspiracy theories and abduction narratives. I wrote characters not myself, with bits of me in them, and it was not about Evernost.
    // `,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //     {
    //       text: `I used to imagine aliens as a girl. Girly aliens: psychic and all about the future of humanity, not invaders bent on destroying human civilization. (When mine want to destroy humanity, it's because I'm not a fan of humanity.) Don't think I'm going to finish this story, though.`,
    //       leftImage: SHARED_IMAGES.noImage,
    //       rightImage: SHARED_IMAGES.noImage,
    //     },
    //   ], // alien abduction
    [
        {
            heading: "Swans",
            text: `\u{201C}Keep your beak to yourself,\u{201D} said the photographer, a watercolor painter in her 50s and snapped a shot: one swan bit another in a sunny October park. I have never been a swan, though Jennie has. I can write about color and reflected light\u{2014} crisp cold air of oncoming autumn \u{2014} and I halt at the birds.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans0
        },
        {
            text: `Say they\u{2019}re a mated couple quarreling in the way of married couples. Patient, calm, unhappy, she looks away. He bites the feathers of her neck. He wants something from her. I find this interaction no more pleasant in swans than in humans. I want to erase it. Turn to the beauty of courtship and disown the anticlimactic ending. I think I\u{2019}m right in rejecting this as an ending.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans1
        },
        {
            text: `But we must go deeper. Perhaps I have the genders wrong. Perhaps bird genders don\u{2019}t map onto human genders (birds\u{2019} sex chromosomes are the reverse of mammals\u{2019}, two of the same for the supposed gentlemen and two different for the ladies). What is the history of this spat? Are they happy, with the occasional storm? Or do they want to be free from one another?`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans2
        },
        {
            text: `The bitten swan sees, elsewhere, a human child running in a torn green bridesmaid\u{2019}s dress. The biter wants the mate back from sunlight and alien drama. Jennie approaches, sleepy, glances at the running girl, smiles as she catches a strain of unearthly music, and plops onto a park bench, opens a loaf of white store-bought bread and tears off a piece for the attacking swan.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans3
        },
        {
            text: `He\u{2019}s distracted, takes it, and both pester Jennie for more, biting her sneakers and jeans. Jennie looks into the lowering sun unflinching and leaves the remaining two thirds of the loaf strewn about the concrete for the swans and the seagulls descending. She becomes a shape of light and flies away.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans4
        },
        {
            text: `Inside the longing swan, only mildly confused by Jennie\u{2019}s transformation, there is a split. Something breaks loose, a thing of pale white light, wintry, longing for sun and distance. It breaks loose within only, only in the inner sky does it fly up, a shape of light. It meets the sun, the clouds \u{2014} but only within.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans5
        },
        {
            text: `In the background a boy in a red shirt kicks a soccer ball, alone and bored. Jennie stills the breeze a moment to let through the sun\u{2019}s warmth. He does not see her. His heart leaps with the next gust of wind into her wildness. He kicks the ball straight into the tree he was aiming for. It bounces back at him. He runs to catch it, barely misses.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans6
        },
        {
            text: `The other park-goers pay no attention, except for the nice mother with her twins in their stroller, knowing that with predators in the park you have to be careful, so she watches him kick the ball \u{2014} it\u{2019}s hypnotic\u{2014} until dusk arrives and his own exhausted mom pulls up in the parking lot after her shift to pick him up. A seagull flies in his mind, dividing it from itself.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans7,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.swans7
        }
    ],
    // [
    //   {
    //     heading: '7/1 - Hell',
    //     text: `Asked about Sonia's favored social causes. Sonia said, “Honestly? Animal rights.” She was embarrassed at first, but turns out she thinks veganism is a moral imperative.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `A college biology course had tipped her over that edge. The professor had explained, casually, there was probably something it was like to be a cat. Halfway through the lecture, he had turned to cruel and pointless mouse experiments. As (he predicted correctly) his audience was horrified, he switched to a slide with a cute picture of mice.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: ` Of course, some students said, “Awwwwwwww,” and he said, “Of course, you react that way. Especially girls. Maternal instincts. That’s why people disapprove of animal experimentation.”`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Shaking, Sonia had raised her hand. She waited so long to be called on that the lecture had moved on, but it happened, and she said, “The problem is not so much that mice are cute as that there’s probably something it’s like to be a mouse.” And from that day, Sonia had been vegan.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `It was a warm and wishy-washy day (I tried to admire the fading lilacs and spireas and could not). I almost laughed, not because Sonia was wrong, but because she was so much righter than she knew.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Does she think plants are any less people than animals? Trees speak to each other through their roots; they feel pain; they tell one another of danger; and this is only what I've read on the internet, not what I've seen elsewhere. Sonia, I almost asked, don't you realize you live in hell? `,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `If I'd said “Eat them but pray for them,” she would have felt nothing but contempt, though she would have smiled and nodded. If I'd said, “Starve yourself, then,” she'd have felt such repulsion (she’d been anorexic) she would never count me as a friend again. People are so weird.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    //   {
    //     text: `Now I want to starve myself, and not just because of the atrocities that are the price of living in this world. How did I forget I was living in hell? I'll pray: for the cells in my body and the elementary particles in the cells, the bacteria in my gut, the plants in my garden, the spiders my mom and I kill, the mice in the walls, Ruff and every other pet I've known.`,
    //     leftImage: SHARED_IMAGES.noImage,
    //     rightImage: SHARED_IMAGES.noImage,
    //   },
    // ], // hell
    [
        {
            heading: "5/12 Red",
            text: `When the woman and her knitting returned, I was doing stylized art and I laughed at my compunctions \u{2014} allegory was of elsewhere, stylization was of elsewhere, any hint of creativity or meaning was of elsewhere? What had been wrong with me as I feared all of that? But they are, I saw then. At least, what's the value of double layers of meaning if the second is not somehow \u{2014} greater, lovelier, more important, deeper, than the visible surface of reality?`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract0
        },
        {
            text: `Forgetting stitches, the knitter Debbie remembers Jennie as \u{2014} a child, a shape of light, a friend, someone who broke fall twilight and set day dawning. Deborah is, apparently, at her daughter\u{2019}s house, with the distorting glass bricks, not her own cozy one-story house. Next to light and grandchildren, she is a shadow, a bit of furniture, but her outline is the central clarity.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract1
        },
        {
            text: `I said she gave that sweater to her grandson, but I am not sure she finished it at all. She may have fallen ill, a heart attack or a stroke or a car accident. Her grandson cherished the remains of the sweater for the rest of his days \u{2014} unless the parents and aunts and uncles, clearing out the house, threw it away and donated her yarn. It wasn\u{2019}t like they didn\u{2019}t have finished hats and sweaters and scarves to remember her by.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract2
        },
        {
            text: `Light turned the Purgatorial walls of the house to stained glass before dissolving them, meeting light in red gift and light in schematic outline and whole that is the old woman. The three lights meet and join, and the boy will wear the radiant red sweater.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract3
        },
        {
            text: `It was shortly after Jennie\u{2019}s arrival that the light began to come through, washing out the details and strengthening shapes and outlines. Pinks and yellows and blues and greens, the grandmother\u{2019}s daughter\u{2019}s favorite colors, before she grew up and had children of her own for Deborah to teach new forms of solitaire.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract4
        },
        {
            text: `Deborah is solving still, puzzles and card games, but as she sits she loses focus. She\u{2019}ll see them again soon. Not just children and grandchildren but parents and grandparents and who knows who else.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract5
        },
        {
            text: `This time I drew schematically, emphasizing the allegory. Gray-blue background, including the woman as if she were as much furniture as the chair, red knitting, and \u{2014} to the side \u{2014} light! yellow light, pink light, warming the room and the woman and the scene. It was like stained glass \u{2014} the glass and color existed to capture the light, to render it visible and tangible.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract6,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.knitterAbstract6
        },
        {
            text: `And a haircut. The brightest thing is the barber's own orangey hair.  Behind them \u{2014} a mirror. Or a window. Mirrors are windows. Or could it be a painting, obscured by light reflecting, a mirror and a window both?`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut5
        },
        {
            text: `Into the abyss of light, higher and deeper and stronger every second, steps not a daughter or a grandson but \u{2014} someone to cut Debbie\u{2019}s hair.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut4
        },
        {
            text: `The light suffuses all despite this officious barber who in this light can only be greeted with a smile.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut1
        },
        {
            text: `The air cleaner hums on the counter. (Her daughter has asthma; daughter must be near \u{2014} and the cats \u{2014} but she\u{2019}s at her daughter\u{2019}s house\u{2014} she hopes Melody, the daughter, got someone to feed the cats.)`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.haircut0
        },
        {
            text: `The cat is a more distinct personage than any human. The sun flows across the back of the cat, begging to be filled by images (I refused, for I was still striving for negative space) and constituting the cat's sinews.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat0,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat0
        },
        {
            text: `Deborah is pleased to see Gus: a good cat, manifestly pleased to see her, though unlikely to get up. There are, she understands from this, more cats. There are very many cats indeed, every cat she has ever known, but right now Gus is enough.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat1,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat1
        },
        {
            text: `Gus, she remembers, died. She never put him to sleep, he crawled out of the house and was never seen again. Some raccoon or crows feasted on his carcass. Here he is, mildly and pleasantly surprised by light, by her, ghostly in the way of everything in this place, more outline than flesh.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat2,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat2
        },
        {
            text: `Gus is, for a while, worrisome. Melody does not like cats, and she is allergic enough they could kill her. Debbie still can't find a way to ask Melody why Gus is here, or whether it is ok, and where they could send him.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat3,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat3
        },
        {
            text: `Then Melody appears one morning and looks at Gus, her blonde hair arranged around her head, without seeing him, though Gus sees her with his not wholly friendly green-gold eyes. Melody dissolves into light, as if she were the ghost. So Debbie stops worrying.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat4,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat4
        },
        {
            text: `Gus begins to seem like a small joke on Melody, who can fuss rather, but perhaps one she will not mind when she finds out, if she finds out. Melody, however, begins to concern Debbie even more. Debbie does not see her again in the following \u{2014} weeks, she wants to say, but the sun only ever grows brighter, unsetting.`,
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat5
        },
        {
            heading: "That's all.",
            effect: ()=>{
                localStorage.removeItem("showRainbow");
                localStorage.setItem("sketch-diaryChapterIndex", "0");
                localStorage.setItem("sketch-diaryTextIndex", "0");
                localStorage.setItem("mere-realityChapterIndex", "0");
                localStorage.setItem("mere-realityTextIndex", "0");
            },
            leftImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat5,
            rightImage: $d67fc5261696adc7$export$83452b2d1d30567a.suncat5
        }
    ]
];



function $c6ffa028de538a05$export$72cc3827ecd65887() {
    return (0, $84df55870a082396$export$ec664d7487540b)((0, $7886e0e2b5160771$export$1bcc85e53db32dd).sketchDiaryCover, [
        "cover"
    ], "sketch-diary-cover");
}
function $c6ffa028de538a05$var$leaveSketchDiary() {
    (0, $84df55870a082396$export$50d8e304f6fed8e6)("sketch-diary");
}
function $c6ffa028de538a05$export$236282b32b16a9b9(goBack) {
    (0, $84df55870a082396$export$2e65e79124cca55d)((0, $7d616f599cf29980$export$56d196d2844d1ca1).white);
    const all = document.getElementsByTagName("html")[0];
    const homeward = (0, $84df55870a082396$export$3900c7b9aa762a08)("Stop snooping", [
        "sketch-diary"
    ], ()=>{
        $c6ffa028de538a05$var$leaveSketchDiary();
        goBack();
    });
    (0, $45d30e0da9a19151$export$3687857846e34983)("sketch-diary", (0, $d67fc5261696adc7$export$9c8bec6150a18d83), (0, $7d616f599cf29980$export$56d196d2844d1ca1).blue);
    all.append(homeward);
}





















































const $ff0b9239068844b7$export$9643a79a281eb0dc = {
    ambassador0: {
        path: new URL($fd90808f7791db8b$exports),
        alt: "Light sketch of man with beard; click to go forward"
    },
    ambassador1: {
        path: new URL($5390322cbd768415$exports),
        alt: "Inked sketch of man with beard; click to go backward"
    },
    ambassador2: {
        path: new URL($b928feae8701ab48$exports),
        alt: "Inked sketch of man with beard, dark browns added; click to go forward"
    },
    ambassador3: {
        path: new URL($509d9e4eb7907e92$exports),
        alt: "Inked sketch of man with beard, mid-brown skin tones added; click to go backward"
    },
    ambassador4: {
        path: new URL($9d7d31a2b17e8e09$exports),
        alt: "Inked sketch of man with beard, dark browns added for hair; click to go forward"
    },
    ambassador5: {
        path: new URL($6b1b002b8381299f$exports),
        alt: "Inked sketch of man with beard, mid-brown skin tones added; click to go backward"
    },
    ambassador6: {
        path: new URL($7f890fbb8699318c$exports),
        alt: "Inked sketch of man with beard, lighter brown skin tones added; click to go forward"
    },
    ambassador7: {
        path: new URL($e5bd2557d057d367$exports),
        alt: "Inked sketch of man with beard, light skin and background tones added; click to go backward"
    },
    niobe0: {
        path: new URL($4106982c75b6778d$exports),
        alt: "Inked blue sketch of woman looking down; click to go forward"
    },
    niobe1: {
        path: new URL($8b479c8432d72a63$exports),
        alt: "Inked blue sketch of woman looking down, black facial feature outlines added; click to go backward"
    },
    niobe2: {
        path: new URL($7072f34c34234072$exports),
        alt: "Inked blue sketch of woman looking down, further black ink shading; click to go forward"
    },
    niobe3: {
        path: new URL($51ad68534bda81fb$exports),
        alt: "Inked blue sketch of woman looking down, splash of dull gold highlight across face; click to go backward"
    },
    niobe4: {
        path: new URL($3b0f2a283bc8a8f3$exports),
        alt: "Inked blue sketch of woman looking down, light paper tones added; click to go forward"
    },
    creep0: {
        path: new URL($a5d816999d0914d3$exports),
        alt: "Pale sketch of man with watch; click to go backward"
    },
    creep1: {
        path: new URL($1d564a74fd5cb650$exports),
        alt: "Darker sketch of man with watch; click to go forward"
    },
    creep2: {
        path: new URL($3f431ce56236ed79$exports),
        alt: "Sketch of man with watch, darker taupe skin tones added; click to go backward"
    },
    creep3: {
        path: new URL($72366bff72c2a8a2$exports),
        alt: "Sketch of man with watch, pale blue hat added; click to go forward"
    },
    creep4: {
        path: new URL($6db5fd8bb2d02178$exports),
        alt: "Sketch of man with watch, pink skin tones added; click to go backward"
    },
    creep5: {
        path: new URL($07a123512557ea63$exports),
        alt: "Sketch of man with watch, ivory and yellowish tones added; click to go forward"
    },
    creep6: {
        path: new URL($4eb1e7f2b0d9dd80$exports),
        alt: "Colored marker sketch of man with watch, completed; click to go forward"
    },
    beau0: {
        path: new URL($db558707c9fc88f4$exports),
        alt: "Black sketch animal eye; click to go forward"
    },
    beau1: {
        path: new URL($5a481a315753567f$exports),
        alt: "Black sketch dog's head, completed; click to go forward"
    },
    beau2: {
        path: new URL($8a3d08e13019f1a6$exports),
        alt: "Black sketch of dog's head and collar; click to go forward"
    },
    beau3: {
        path: new URL($b5586dbdd8fe9380$exports),
        alt: "Black sketch of dog's torso and front leg; click to go forward"
    },
    beau4: {
        path: new URL($349b9c43a50cd462$exports),
        alt: "Black sketch of dog with two legs showing; click to go forward"
    },
    beau5: {
        path: new URL($ede83f4e9e683926$exports),
        alt: "Black sketch of dog with all legs showing; click to go forward"
    },
    beau6: {
        path: new URL($72c6b32f82741846$exports),
        alt: "Complete black sketch of dog with all legs and tail; click to go forward"
    },
    knitter0: {
        path: new URL($e4530e530905df36$exports),
        alt: "Blue ink beginnings of drawing of woman bending her head over; Click to go forward"
    },
    knitter1: {
        path: new URL($aeb783e8b9e3d80f$exports),
        alt: "Blue ink beginnings of drawing of woman with black glasses added; Click to go forward"
    },
    knitter2: {
        path: new URL($71353f77322607e6$exports),
        alt: "Blue and black ink drawing of woman in glasses with brown shades added; Click to go forward"
    },
    knitter3: {
        path: new URL($24c488c79b69f1df$exports),
        alt: "Blue, black, and brown ink drawing of woman in glasses with red knitting project added; Click to go forward"
    },
    knitter4: {
        path: new URL($9c75fab25d740e97$exports),
        alt: "Ink drawing of woman knitting with pencil texture added; Click to go forward"
    },
    knitter5: {
        path: new URL($7f45c3925de5b430$exports),
        alt: "Ink and pencil drawing of woman knitting with paper color added; Click to go forward"
    },
    knitter6: {
        path: new URL($05290cd9e04c586a$exports),
        alt: "Completed ink and pencil drawing of woman knitting something red; click to go forward"
    },
    wrestle0: {
        path: new URL($d3920cbc86ea7439$exports),
        alt: "Pale sketch of woman and boy wrestling; click to go forward"
    },
    wrestle1: {
        path: new URL($fc607687f77d15c4$exports),
        alt: "Darker ballpoint pen sketch of woma and boy wrestling; click to go forward"
    },
    wrestle2: {
        path: new URL($fb48a5ac1592cecb$exports),
        alt: "Sketch of woman and boy wrestling with lighter blue of woman's jeans and jacket added; click to go forward"
    },
    wrestle3: {
        path: new URL($5d22c5337b27359c$exports),
        alt: "Sketch of woman and boy wrestling with olive green of boy's hoodie added; click to go forward"
    },
    wrestle4: {
        path: new URL($19d6e2f46b45e8ca$exports),
        alt: "Sketch of woman and boy wrestling with woman's red hair added; click to go forward"
    },
    wrestle5: {
        path: new URL($ddb2140585acb11b$exports),
        alt: "Sketch of woman and boy wrestling with yellowish skin tones added; click to go forward"
    },
    wrestle6: {
        path: new URL($779c950f5197586f$exports),
        alt: "Sketch of woman and boy wrestling with paper tones added; click to go forward"
    },
    wrestle7: {
        path: new URL($ba58c8362011c619$exports),
        alt: "Complete sketch of woman and boy wrestling; click to go forward"
    },
    swans0: {
        path: new URL($e4e1705eb530c953$exports),
        alt: "Light outline of one swan biting another; click to go forward"
    },
    swans1: {
        path: new URL($e07bc81d4f2af1b5$exports),
        alt: "Darker outline of one swan biting another with park in background in dark greens; click to go forward"
    },
    swans2: {
        path: new URL($c517232a2b8da59d$exports),
        alt: "One swan biting another in a park with red of turning trees and red-brown of dirt added; click to go forward"
    },
    swans3: {
        path: new URL($c19a90eebee6864d$exports),
        alt: "One swan biting another in a park with green grass and trees added; click to go forward"
    },
    swans4: {
        path: new URL($f60430ffd4c475af$exports),
        alt: "One swan biting another in a park with gray mountains added; click to go forward"
    },
    swans5: {
        path: new URL($a59d25e4eeae3dc2$exports),
        alt: "One swan biting another in a park with purple highlights added to the mountains; click to go forward"
    },
    swans6: {
        path: new URL($f34654d752e2da72$exports),
        alt: "One swan biting another in a park with blue sky added"
    },
    swans7: {
        path: new URL($fef5f2c5b8f5676d$exports),
        alt: "Completed marker drawing of one swan biting another in a park"
    }
};
const $ff0b9239068844b7$var$swanStanzas = [
    `Keep your beak to yourself.
You do not love this light.
This false light shouts.
Turn away.`,
    `Look at me, I dare you.
No god, no maiden, here \u{2014} just animals 
biting animals; they even bore themselves.
Turn away.`,
    `Turn away.
Show me real fall, real leaves.
You can\u{2019}t. Show me you.
You can\u{2019}t. Show me me. I dare you.`,
    `Turn away.
Yes, there is light even in the knife
You are trying to cut out your heart with.
For love\u{2019}s sake put down the knife.`,
    `Turn to darkness,
for this is not light.
Turn the knife on me or,
for love\u{2019}s sake, put it down.`,
    `They mean to turn the knife on me;
they\u{2019}re even right, but do not stain 
them with your blood as well as mine.
Put down the knife, for love\u{2019}s sake.`,
    `Keep your beak to yourself
and watch the leaves turn and the children play \u{2014}
put down the knife, or maybe I\u{2019}ll just let you cut you out of me
and me out of you.`,
    `Keep your beak to yourself,
because, yes, I want something with you
and the leaves and the swans.
I want the gold back in the green`,
    `Put the gold back in the green,
because, yes, the god is here,
the maiden is here,
I am here.`
];
const $ff0b9239068844b7$export$e3d65da4038a9a32 = [
    [
        {
            title: `Mere reality, take 200`,
            text: `So, I'm trying to abandon elsewhere for real, but what does that leave me? This guy I'm sketching, say.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador0
        },
        {
            text: `Grinning stranger, free from the Wetcanvas reference image library.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador1
        },
        {
            text: `Guess I just don't care enough to get him right. Maybe that's good? Maybe attentiveness, or at least the attentiveness that yields \u{2014} a sense, an impression, a love \u{2014} is vision and of elsewhere. Maybe it's more than mere reality. Heh. Bad excuse.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador2
        },
        {
            text: `If I believed in elsewhere I'd believe I knew something about him. I'd believe he leads a small-town drama company. Works with kids. Big personality to match his big grin. Plays the Beast in Beauty and the Beast.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador3
        },
        {
            text: `That grin is so crooked it's driving me nuts. But I'm already coloring. Tooooo late.)`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador4
        },
        {
            text: `No, not of elsewhere. Reality is guiding my hand; reality yielded these contours (minus mistakes). Still, the impressions they leave \u{2014} created or recorded? Are they visible to any eye? Does a drawing make them more visible than in a photograph? Am I bringing out something already there or creating something new?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador5
        },
        {
            text: `Is the smile real? His eyes are smiling too, but you can learn to fake that.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador6
        },
        {
            text: `Why, when you see people smiling in a certain kind of photo, does it always feel fake, whether it is or not? Why do I think I'm going to be staring at this awful thing all night?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador7,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.ambassador7
        }
    ],
    [
        {
            text: `A solemnity in ink. Heaviness. Like this one better though it's worse, technically speaking. Even worse.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe0
        },
        {
            text: `Remember when I wanted to draw portraits for a living? Liked the idea of showing people their souls. Bringing them closer to elsewhere and themselves, but I didn't have the patience. Maybe I'll leave elsewhere out, and I'll be able to find the patience now?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe1
        },
        {
            text: `Mere reality is heavy, solemn, ugly, wrong. I mean, it would be fine if mere reality were only one thing, but if it's everything I don't think I can stand it.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe2
        },
        {
            text: "I guess I need to learn to see joy and beauty without elsewhere? Why does that feel even worse?",
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe3
        },
        {
            text: `A sad, concentrated old woman. That's me in the story in my head \u{2014} miserable, pensive, dull, focused on something in my hands, something small to the point of vanishing. Unless the small thing is elsewhere and the great thing is the world?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.niobe4
        }
    ],
    [
        {
            text: "Bah, more portraits. Is this even worth it? I kind of hate this dude already.",
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep0
        },
        {
            text: `If I believed in elsewhere, I'd say he's thinking, but actively, about doing something. Scheming. Awkward and rumpled, stuck inside himself. Predatory.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep1
        },
        {
            text: `Some socially acceptable slimy jerk who talks about fishing and cars and makes lewd comments about the women at his office. Who feels cynical and superior to you no matter who you are.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep2
        },
        {
            text: `What if he's a representaiton of me. Cold and empty, leering after beauty that is not mine?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep3
        },
        {
            text: `It didn't feel like being that person \u{2014} elsewhere. It was terrifying sometimes, but always glorious and not \u{2014} being locked out.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep4
        },
        {
            text: `I thought I refused elsewhere. But what if elsewhere refused me, because I was like that?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep5
        },
        {
            text: `Of course, it's all just stereotypes. Really he's just some poor guy I know nothing about, and this drawing is making an uninformative photo into a gargoyle.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.creep6
        }
    ],
    [
        {
            text: `My brother Dave and I had a golden retriever growing up. Ruff. He died when I was seventeen. I didn't have time for him as a teenager.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau0
        },
        {
            text: `Felt bad when he got cancer, though. Wanted to send him elsewhere. I thought of that every night, either healing for him or letting him go there. When Mom had him put to sleep I imagined I was talking with him.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau1
        },
        {
            text: `He assured me he already was elsewhere. Offered to let me come after him. Knew that's where I belonged. I almost did.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau2
        },
        {
            text: `Mom refused to get another dog. Dad kind of wanted one, but Dad had also wanted Ruff and then did basically nothing to help take care of him, so he didn't press the issue.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau3
        },
        {
            text: `Dave's wild about dogs. He and his wife Holly have three. This is their lab Beau, who died a year ago. I told Dave I was drawing real things, and he wants a portrait.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau4
        },
        {
            text: `Shouldn't have done it all in black. Too somber for Dave and Holly.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau5
        },
        {
            text: `Just texted them the picture and got the predictable exclamations from Holly (she's so sweet and stressed) and a shy approval from Dave. I'll mail it next week.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.beau6
        }
    ],
    [
        {
            text: `Gah, this one is actually good, and it's also the most...of elsewhere...yet. I guess lots of people wouldn't see it that way, since there's nothing impossible or strange about it.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter0
        },
        {
            text: `But elsewhere isn't just fantasy. It's second meanings, supposedly deeper but probably just made-up meanings. And the idea of loving your creation more than yourself. That your creation is more real than you are.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter1
        },
        {
            text: `Knitter's smiling. Her glasses let her see her work.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter2
        },
        {
            text: `Maybe this is not of elsewhere, because, even though it contains elsewhere, mere reality is more vivid. The red knitting is glowing but simple, too simple, and red is the color of evil or animality.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter3
        },
        {
            text: `The woman, on the other hand, has depth and pattern, light and shadow. She's the real center.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter4
        },
        {
            text: `I've almost thrown this thing away three times. But I can't.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter5
        },
        {
            text: `Ok, it's done. It's going into a drawer and there it stays.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.knitter6
        }
    ],
    [
        {
            text: `More strangers, these thoroughly prosaic and un-elswhere-y.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle0
        },
        {
            text: `They remind me so much of Mom and Dave when we were all younger it's scary. The woman's hair is even coppery red.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle1
        },
        {
            text: `And now I'm like, but what if linking strangers to family is of elsewhere?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle2
        },
        {
            text: `What does it mean that this is a scribbly mess? Just that I'm lazy? Or that I care too much about elsewhere to get this world right?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle3
        },
        {
            text: `Or is the scribbly abstraction itself elsewhere? This is getting ridiculous.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle4
        },
        {
            text: `I wonder what's going on. Are they playing, or is she restraining the kid?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle5
        },
        {
            text: `I don't want to keep doing this. Every chicken scratch of a colored pencil is a struggle. Every sentence I write for work is a struggle.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle6
        },
        {
            text: `Can't sleep.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle7,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.wrestle7
        }
    ],
    [
        {
            text: `Need to shower. Need something cheerful. What is joy that is not of elsewhere? Joy earthly and not marvelous? Here are some swans in a park in the fall.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans0,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans0
        },
        {
            text: "The one is grooming the other one. Or maybe biting. Kinda silly.",
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans1,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans1
        },
        {
            text: `Silliness makes me want to bite something, because without elsewhere it's all silliness now, or sadness.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans2,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans2
        },
        {
            text: `Are these brilliant colors of elsewhere? Leaves\u{2019} red, that wild yellow and green that say "follow me." The cold blue. That cold blue calls me almost as elsewhere calls me. Violently.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans3,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans3
        },
        {
            text: `And then I'm like, maybe I'm welcome to the beauty as long as I don't think of it as elsewhere. But what else do I think elsewhere is, if not beauty beyond all desiring?`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans4,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans4
        },
        {
            text: `Swans are supposed to be about purity and grace. These ones aren't. They're colorful, like Saruman when he takes off his white robe in Lord of the Rings. Playful. SILLY, goddammit.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans5,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans5
        },
        {
            text: `Pretty sure this thing is called "Keep your beak to yourself." I think it's done. Gonna post it online.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans6,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans6
        },
        {
            text: `This is not even worth the paper it's drawn on. Too simple. Messy. Loud. Cold.`,
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans7,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans7
        },
        {
            effect: ()=>{
                localStorage.setItem("showRainbow", "true");
                localStorage.setItem("mere-realityChapterIndex", "0");
                localStorage.setItem("mere-realityTextIndex", "0");
                localStorage.setItem("sketch-diaryChapterIndex", "0");
                (0, $84df55870a082396$export$50d8e304f6fed8e6)("reader-art");
                localStorage.setItem("sketch-diaryTextIndex", "0");
                const music = document.getElementById("mere-reality-music");
                const textContainer = document.getElementById("mere-reality-reader-text-container");
                textContainer.classList.add("swans-bg");
                const swanStanzaDivs = $ff0b9239068844b7$var$swanStanzas.map((stanza)=>{
                    const div = document.createElement("div");
                    div.classList.add("mere-reality");
                    div.innerText = stanza;
                    return div;
                });
                function addNextSwanStanza(index) {
                    (0, $84df55870a082396$export$50d8e304f6fed8e6)("swan-stanza");
                    const nthSwanStanza = swanStanzaDivs.shift();
                    nthSwanStanza.classList.add("swan-stanza", `swan-stanza-fade-out-${index}`);
                    textContainer.append(nthSwanStanza);
                }
                music.addEventListener("ended", ()=>{
                    document.getElementById("homeward")?.click();
                });
                music?.play();
                addNextSwanStanza(0);
                setTimeout(()=>addNextSwanStanza(1), 8000);
                setTimeout(()=>addNextSwanStanza(2), 18267);
                setTimeout(()=>addNextSwanStanza(3), 26283);
                setTimeout(()=>addNextSwanStanza(4), 35067);
                setTimeout(()=>addNextSwanStanza(5), 41000);
                setTimeout(()=>addNextSwanStanza(6), 48300);
                setTimeout(()=>addNextSwanStanza(7), 57237);
                setTimeout(()=>addNextSwanStanza(8), 64383);
            },
            leftImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans7,
            rightImage: $ff0b9239068844b7$export$9643a79a281eb0dc.swans7
        }
    ]
];



function $df9943937b2a0401$export$a28c2dd61a24f753() {
    const showRainbow = !!localStorage.getItem("showRainbow") ?? false;
    if (showRainbow) return (0, $c6ffa028de538a05$export$72cc3827ecd65887)();
    return (0, $84df55870a082396$export$ec664d7487540b)((0, $7886e0e2b5160771$export$1bcc85e53db32dd).mereRealityCover, [
        "cover"
    ], "mere-reality-cover");
}
function $df9943937b2a0401$var$leaveMereReality() {
    (0, $84df55870a082396$export$50d8e304f6fed8e6)("mere-reality");
}
var $968ad2ccf108ee11$exports = {};
$968ad2ccf108ee11$exports = new URL("swans_mixdown.05cafefc.mp3", import.meta.url).toString();


function $df9943937b2a0401$export$2938380aa0845b6(goBack) {
    const showRainbow = !!localStorage.getItem("showRainbow") ?? false;
    if (showRainbow) {
        (0, $c6ffa028de538a05$export$236282b32b16a9b9)(goBack);
        return;
    }
    (0, $84df55870a082396$export$2e65e79124cca55d)((0, $7d616f599cf29980$export$56d196d2844d1ca1).white);
    const all = document.getElementsByTagName("html")[0];
    all.append((0, $84df55870a082396$export$6a1f9803a6325dab)(new URL($968ad2ccf108ee11$exports), [
        "mere-reality"
    ], "mere-reality-music"));
    const homeward = (0, $84df55870a082396$export$3900c7b9aa762a08)("Stop reading", [
        "mere-reality"
    ], ()=>{
        $df9943937b2a0401$var$leaveMereReality();
        goBack();
    });
    (0, $45d30e0da9a19151$export$3687857846e34983)("mere-reality", (0, $ff0b9239068844b7$export$e3d65da4038a9a32), (0, $7d616f599cf29980$export$56d196d2844d1ca1).dullOrange);
    all.append(homeward);
}


const $7886e0e2b5160771$export$71f0e2652badacfb = [
    {
        name: "mereReality",
        showCover: (0, $df9943937b2a0401$export$a28c2dd61a24f753),
        show: (0, $df9943937b2a0401$export$2938380aa0845b6)
    }
];
var $b658cfe875a4bb61$exports = {};
$b658cfe875a4bb61$exports = new URL("mereRealityCover.75f36aaa.jpg", import.meta.url).toString();


var $086584eab2b41737$exports = {};
$086584eab2b41737$exports = new URL("mySketchDiaryCover.d003b868.jpg", import.meta.url).toString();


const $7886e0e2b5160771$export$1bcc85e53db32dd = {
    mereRealityCover: {
        path: new URL($b658cfe875a4bb61$exports),
        alt: "Cardboard sketchbook with black banner reading Mere Reality"
    },
    sketchDiaryCover: {
        path: new URL($086584eab2b41737$exports),
        alt: 'Cardboard sketchbook with white banner reading "My rainbow sketch diary" in many colors'
    }
};




function $107a7da779cf8f80$var$leaveBooks() {
    (0, $84df55870a082396$export$50d8e304f6fed8e6)("books");
}
function $107a7da779cf8f80$export$9a6f8dfe0e46564a() {
    (0, $84df55870a082396$export$2e65e79124cca55d)((0, $7d616f599cf29980$export$56d196d2844d1ca1).white);
    const all = document.getElementsByTagName("html")[0];
    const covers = (0, $7886e0e2b5160771$export$71f0e2652badacfb).map((book)=>{
        const cover = book.showCover();
        cover.classList.add("books");
        cover.addEventListener("click", ()=>{
            $107a7da779cf8f80$var$leaveBooks();
            book.show($107a7da779cf8f80$export$9a6f8dfe0e46564a);
        });
        cover.style.transform = `rotate(${Math.random() * 80 - 40}deg)`;
        return cover;
    });
    const spreadOutBooks = (0, $84df55870a082396$export$45a83f42d92f1eb9)(covers, [
        "books"
    ], "spread-out-books");
    all.append(spreadOutBooks);
}


window.onload = ()=>{
    (0, $107a7da779cf8f80$export$9a6f8dfe0e46564a)();
};


//# sourceMappingURL=index.0d9c535a.js.map
